import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  Byte: any;
  Currency: any;
  DID: any;
  Date: any;
  DateTime: any;
  Duration: any;
  EmailAddress: any;
  GUID: any;
  HSL: any;
  HSLA: any;
  HexColorCode: any;
  Hexadecimal: any;
  IBAN: any;
  IPv4: any;
  IPv6: any;
  ISBN: any;
  ISO8601Duration: any;
  JSON: any;
  JSONObject: any;
  JWT: any;
  Latitude: any;
  LocalDate: any;
  LocalEndTime: any;
  LocalTime: any;
  Long: any;
  Longitude: any;
  MAC: any;
  NegativeFloat: any;
  NegativeInt: any;
  NonEmptyString: any;
  NonNegativeFloat: any;
  NonNegativeInt: any;
  NonPositiveFloat: any;
  NonPositiveInt: any;
  ObjectID: any;
  PhoneNumber: any;
  Port: any;
  PositiveFloat: any;
  PositiveInt: any;
  PostalCode: any;
  RGB: any;
  RGBA: any;
  SafeInt: any;
  Time: any;
  Timestamp: any;
  URL: any;
  USCurrency: any;
  UUID: any;
  UnsignedFloat: any;
  UnsignedInt: any;
  UtcOffset: any;
  Void: any;
};

export type BasicUser = {
  __typename?: 'BasicUser';
  avatarUrl?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
};

export type Company = {
  __typename?: 'Company';
  domain: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CompanyFinancialAccount = {
  __typename?: 'CompanyFinancialAccount';
  financialAccountTypeId: Scalars['ID'];
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
};

export type CompanyProductCategory = {
  __typename?: 'CompanyProductCategory';
  defaultRequiredExtensionInDays: Scalars['Int'];
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
};

export type Config = {
  __typename?: 'Config';
  buildNumber: Scalars['String'];
  defaultPaginationRowsPerPage: Array<Maybe<Scalars['UnsignedInt']>>;
  isAutomationAllowed: Scalars['Boolean'];
  isDevelopment: Scalars['Boolean'];
  isPushNotificationEnabled: Scalars['Boolean'];
  isSystemInMaintenanceMode: Scalars['Boolean'];
  isTourEntriesAllowed: Scalars['Boolean'];
  toastAutoHideDuration: Scalars['UnsignedInt'];
  version: Scalars['String'];
};

export type Contract = {
  __typename?: 'Contract';
  balanceAmount?: Maybe<Scalars['Float']>;
  companyProductCategoryId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['BigInt']>;
  createdBy?: Maybe<BasicUser>;
  customerAddress?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  customerPhone?: Maybe<Scalars['String']>;
  engineCode?: Maybe<Scalars['String']>;
  events?: Maybe<Array<ContractEvent>>;
  expirationDate?: Maybe<Scalars['BigInt']>;
  files?: Maybe<Array<ContractFile>>;
  financialAccounts?: Maybe<Array<ContractFinancialAccount>>;
  frameCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isDeletable?: Maybe<Scalars['Boolean']>;
  isDraftUpdatable?: Maybe<Scalars['Boolean']>;
  isEffectiveUpdatable?: Maybe<Scalars['Boolean']>;
  isExecutable?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isExtendable?: Maybe<Scalars['Boolean']>;
  isFileCreatable?: Maybe<Scalars['Boolean']>;
  isListable?: Maybe<Scalars['Boolean']>;
  isMorePrincipalRequestable?: Maybe<Scalars['Boolean']>;
  isPartialPaymentable?: Maybe<Scalars['Boolean']>;
  isPawnTransaction: Scalars['Boolean'];
  isPrintable?: Maybe<Scalars['Boolean']>;
  isReclaimable?: Maybe<Scalars['Boolean']>;
  isRepairAddable?: Maybe<Scalars['Boolean']>;
  isSellable?: Maybe<Scalars['Boolean']>;
  itemDescription?: Maybe<Scalars['String']>;
  lastExpirationDate?: Maybe<Scalars['BigInt']>;
  lastInterestStartingFromDate?: Maybe<Scalars['BigInt']>;
  lastPrincipalAmount?: Maybe<Scalars['Float']>;
  netAmount?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  numberOfDaysToLastExpirationDate?: Maybe<Scalars['Int']>;
  numberOfExtensionTimes?: Maybe<Scalars['UnsignedInt']>;
  numberOfPawnDays?: Maybe<Scalars['UnsignedInt']>;
  plateNumber?: Maybe<Scalars['String']>;
  principalAmount: Scalars['UnsignedFloat'];
  repairAmount?: Maybe<Scalars['UnsignedFloat']>;
  status: Scalars['String'];
  updatedAt?: Maybe<Scalars['BigInt']>;
  updatedBy?: Maybe<BasicUser>;
  withinDayId: Scalars['String'];
  writtenDate?: Maybe<Scalars['BigInt']>;
};

export type ContractEvent = {
  __typename?: 'ContractEvent';
  additionalPrincipalAmount?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  balanceAmount?: Maybe<Scalars['Float']>;
  createdAt: Scalars['BigInt'];
  createdBy: BasicUser;
  customerOwedInterestAmount?: Maybe<Scalars['Float']>;
  expirationDate?: Maybe<Scalars['BigInt']>;
  financialAccounts?: Maybe<Array<ContractFinancialAccount>>;
  id: Scalars['ID'];
  interestAmount?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  numberOfDays?: Maybe<Scalars['Int']>;
  partyName?: Maybe<Scalars['String']>;
  previousBalanceAmount?: Maybe<Scalars['Float']>;
  previousPrincipalAmount?: Maybe<Scalars['Float']>;
  principalAmount?: Maybe<Scalars['Float']>;
  repairAmount?: Maybe<Scalars['Float']>;
  soldAmount?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
};

export type ContractFile = {
  __typename?: 'ContractFile';
  category?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['BigInt']>;
  createdBy?: Maybe<BasicUser>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDeletable?: Maybe<Scalars['Boolean']>;
  isUpdatable?: Maybe<Scalars['Boolean']>;
  mimeType: Scalars['String'];
  name: Scalars['String'];
  size: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['BigInt']>;
  updatedBy?: Maybe<BasicUser>;
};

export type ContractFilterInput = {
  contractStatuses?: InputMaybe<FilterIdsInput>;
  contractType?: InputMaybe<FilterQueryInput>;
  customerPhone?: InputMaybe<FilterQueryInput>;
  expirationDate?: InputMaybe<DateFilterQueryInput>;
  isExpired?: InputMaybe<FilterBooleanInput>;
  netAmount?: InputMaybe<NumberFilterInput>;
  principalAmount?: InputMaybe<NumberFilterInput>;
  productCategories?: InputMaybe<FilterIdsInput>;
  text?: InputMaybe<FilterQueryInput>;
  writtenDate?: InputMaybe<DateFilterQueryInput>;
};

export type ContractFinancialAccount = {
  __typename?: 'ContractFinancialAccount';
  amount?: Maybe<Scalars['Float']>;
  companyFinancialAccountId: Scalars['ID'];
  id: Scalars['ID'];
};

export type ContractFinancialAccountInput = {
  amount: Scalars['Float'];
  companyFinancialAccountId: Scalars['ID'];
};

export type Coordinates = {
  __typename?: 'Coordinates';
  latitude: Scalars['Longitude'];
  longitude: Scalars['Latitude'];
};

export type CreateContractInput = {
  isPawnTransaction: Scalars['Boolean'];
  withinDayId: Scalars['BigInt'];
  writtenDate: Scalars['BigInt'];
};

export type CreateContractResponse = {
  __typename?: 'CreateContractResponse';
  contract?: Maybe<Contract>;
  result: MutationWithValidationResponse;
};

export type CreateIncomeExpenseResponse = {
  __typename?: 'CreateIncomeExpenseResponse';
  incomeExpense?: Maybe<IncomeExpense>;
  result: MutationWithValidationResponse;
};

export type CreateInvestedPrincipalResponse = {
  __typename?: 'CreateInvestedPrincipalResponse';
  investedPrincipal?: Maybe<InvestedPrincipal>;
  result: MutationWithValidationResponse;
};

export type CreateMoneyTransferResponse = {
  __typename?: 'CreateMoneyTransferResponse';
  moneyTransfer?: Maybe<MoneyTransfer>;
  result: MutationWithValidationResponse;
};

export type DailyReportSummary = {
  __typename?: 'DailyReportSummary';
  beginningBalance?: Maybe<Scalars['Float']>;
  buySellInterestAmount?: Maybe<Scalars['Float']>;
  buySellPrincipalAmount?: Maybe<Scalars['Float']>;
  endingBalance?: Maybe<Scalars['Float']>;
  expense?: Maybe<Scalars['Float']>;
  income?: Maybe<Scalars['Float']>;
  moneyTransferCashInAmount?: Maybe<Scalars['Float']>;
  moneyTransferCashOutAmount?: Maybe<Scalars['Float']>;
  moneyTransferFee?: Maybe<Scalars['Float']>;
  numberOfTransactions?: Maybe<Scalars['PositiveInt']>;
  overrideEndingBalance?: Maybe<Scalars['Float']>;
  pawnInterestAmount?: Maybe<Scalars['Float']>;
  pawnPrincipalAmount?: Maybe<Scalars['Float']>;
  principalReceived?: Maybe<Scalars['Float']>;
  totalAmountInTransactions?: Maybe<Scalars['Float']>;
  totalBuySellPrincipleAmount?: Maybe<Scalars['Float']>;
  totalInterestAmount?: Maybe<Scalars['Float']>;
  totalPawnPrincipleAmount?: Maybe<Scalars['Float']>;
};

export type DailyReportTransaction = {
  __typename?: 'DailyReportTransaction';
  amount?: Maybe<Scalars['Float']>;
  buySellInterestAmount?: Maybe<Scalars['Float']>;
  buySellPrincipalAmount?: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  expense?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  income?: Maybe<Scalars['Float']>;
  moneyTransferCashInAmount?: Maybe<Scalars['Float']>;
  moneyTransferCashOutAmount?: Maybe<Scalars['Float']>;
  moneyTransferFee?: Maybe<Scalars['Float']>;
  pawnInterestAmount?: Maybe<Scalars['Float']>;
  pawnPrincipalAmount?: Maybe<Scalars['Float']>;
  pawnPrincipalRecoupeAmount?: Maybe<Scalars['Float']>;
  serviceName: Scalars['String'];
  timestamp: Scalars['PositiveInt'];
  transactionId: Scalars['String'];
};

export type DateFilterInput = {
  end?: InputMaybe<Scalars['Date']>;
  endValue?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Date']>;
  startValue?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['Date']>;
  timePrefix?: InputMaybe<Scalars['String']>;
  timeValue?: InputMaybe<Scalars['Int']>;
};

export type DateFilterQueryInput = {
  operatorTypeId?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<DateFilterInput>;
};

export type ExecuteContractInput = {
  createdAt: Scalars['BigInt'];
  financialAccounts?: InputMaybe<Array<ContractFinancialAccountInput>>;
  notes?: InputMaybe<Scalars['String']>;
  numberOfPawnDays?: InputMaybe<Scalars['UnsignedInt']>;
  principalAmount: Scalars['Float'];
  repairAmount?: InputMaybe<Scalars['Float']>;
};

export type ExportReportResponse = {
  __typename?: 'ExportReportResponse';
  code: Scalars['Int'];
  downloadableUrl: Scalars['URL'];
  message?: Maybe<Scalars['String']>;
};

export type ExtendContractInput = {
  amount: Scalars['UnsignedFloat'];
  createdAt: Scalars['BigInt'];
  customerOwedInterestAmount: Scalars['Float'];
  financialAccounts?: InputMaybe<Array<ContractFinancialAccountInput>>;
  interestAmount: Scalars['UnsignedFloat'];
  notes?: InputMaybe<Scalars['String']>;
  numberOfDays: Scalars['UnsignedInt'];
  partyName?: InputMaybe<Scalars['String']>;
};

export type FieldValidationError = {
  __typename?: 'FieldValidationError';
  code: Scalars['String'];
  field: Scalars['String'];
  reason: Scalars['String'];
};

export type FilterBooleanInput = {
  query?: InputMaybe<Scalars['String']>;
};

export type FilterIdsInput = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type FilterQueryInput = {
  operatorTypeId?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
};

export type FinancialAccountType = {
  __typename?: 'FinancialAccountType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type GetDailyReportResponse = {
  __typename?: 'GetDailyReportResponse';
  dateKey: Scalars['PositiveInt'];
  summary: DailyReportSummary;
  transactions?: Maybe<Array<DailyReportTransaction>>;
};

export type GetInvestedPrincipalReportResponse = {
  __typename?: 'GetInvestedPrincipalReportResponse';
  amount: Scalars['Float'];
  investor?: Maybe<BasicUser>;
  investorUserId: Scalars['ID'];
};

export type GetMonthlyReportResponse = {
  __typename?: 'GetMonthlyReportResponse';
  days?: Maybe<Array<MonthlyReportDay>>;
  monthKey: Scalars['PositiveInt'];
  summary?: Maybe<MonthlyReportSummary>;
};

export type GetPeriodReportResponse = {
  __typename?: 'GetPeriodReportResponse';
  periodReport?: Maybe<PeriodReport>;
  result: MutationWithValidationResponse;
};

export type IncomeExpense = {
  __typename?: 'IncomeExpense';
  amount: Scalars['Float'];
  companyFinancialAccountId: Scalars['ID'];
  createdAt?: Maybe<Scalars['BigInt']>;
  createdBy?: Maybe<BasicUser>;
  id: Scalars['ID'];
  isDeletable?: Maybe<Scalars['Boolean']>;
  isUpdatable?: Maybe<Scalars['Boolean']>;
  notes: Scalars['String'];
  transactionDate: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['BigInt']>;
  updatedBy?: Maybe<BasicUser>;
};

export type IncomeExpenseFilterInput = {
  amount?: InputMaybe<NumberFilterInput>;
  text?: InputMaybe<FilterQueryInput>;
  transactionDate?: InputMaybe<DateFilterQueryInput>;
};

export type IncomeExpenseInput = {
  amount: Scalars['Float'];
  companyFinancialAccountId: Scalars['ID'];
  notes: Scalars['String'];
  transactionDate: Scalars['BigInt'];
};

export type InvestedPrincipal = {
  __typename?: 'InvestedPrincipal';
  amount: Scalars['Float'];
  companyFinancialAccountId: Scalars['ID'];
  createdAt?: Maybe<Scalars['BigInt']>;
  createdBy?: Maybe<BasicUser>;
  id: Scalars['ID'];
  interestRate: Scalars['Float'];
  investor?: Maybe<BasicUser>;
  investorUserId: Scalars['ID'];
  isDeletable?: Maybe<Scalars['Boolean']>;
  isUpdatable?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  transactionDate: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['BigInt']>;
  updatedBy?: Maybe<BasicUser>;
};

export type InvestedPrincipalFilterInput = {
  amount?: InputMaybe<NumberFilterInput>;
  shopInvestor?: InputMaybe<FilterIdsInput>;
  text?: InputMaybe<FilterQueryInput>;
  transactionDate?: InputMaybe<DateFilterQueryInput>;
};

export type InvestedPrincipalInput = {
  amount: Scalars['Float'];
  companyFinancialAccountId: Scalars['ID'];
  interestRate: Scalars['Float'];
  investorUserId: Scalars['ID'];
  notes: Scalars['String'];
  transactionDate: Scalars['BigInt'];
};

export type MoneyTransfer = {
  __typename?: 'MoneyTransfer';
  amount: Scalars['Float'];
  createdAt?: Maybe<Scalars['BigInt']>;
  createdBy?: Maybe<BasicUser>;
  customerName?: Maybe<Scalars['String']>;
  fee: Scalars['Float'];
  fromCompanyFinancialAccountId: Scalars['ID'];
  id: Scalars['ID'];
  isDeletable?: Maybe<Scalars['Boolean']>;
  isUpdatable?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  toCompanyFinancialAccountId: Scalars['ID'];
  transferredDate: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['BigInt']>;
  updatedBy?: Maybe<BasicUser>;
};

export type MoneyTransferFilterInput = {
  amount?: InputMaybe<NumberFilterInput>;
  text?: InputMaybe<FilterQueryInput>;
  transferredDate?: InputMaybe<DateFilterQueryInput>;
};

export type MoneyTransferInput = {
  amount: Scalars['Float'];
  customerName?: InputMaybe<Scalars['String']>;
  fee: Scalars['Float'];
  fromCompanyFinancialAccountId: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
  toCompanyFinancialAccountId: Scalars['ID'];
  transferredDate: Scalars['BigInt'];
};

export type MonthlyReportDay = {
  __typename?: 'MonthlyReportDay';
  buySellInterestAmount?: Maybe<Scalars['Float']>;
  buySellPrincipalAdvanceAmount?: Maybe<Scalars['Float']>;
  buySellPrincipalRecoupeAmount?: Maybe<Scalars['Float']>;
  dateKey: Scalars['PositiveInt'];
  endingBalance?: Maybe<Scalars['Float']>;
  endingBalanceDifference?: Maybe<Scalars['Float']>;
  moneyTransferAmount?: Maybe<Scalars['Float']>;
  moneyTransferFee?: Maybe<Scalars['Float']>;
  numberOfDaysToCalculatePrincipalInterest?: Maybe<Scalars['PositiveInt']>;
  overrideEndingBalance?: Maybe<Scalars['Float']>;
  pawnInterestAmount?: Maybe<Scalars['Float']>;
  pawnPrincipalAdvanceAmount?: Maybe<Scalars['Float']>;
  pawnPrincipalRecoupeAmount?: Maybe<Scalars['Float']>;
  principalReceived?: Maybe<Scalars['Float']>;
  totalBuySellPrincipleAmount?: Maybe<Scalars['Float']>;
  totalExpense?: Maybe<Scalars['Float']>;
  totalIncome?: Maybe<Scalars['Float']>;
  totalPawnPrincipleAmount?: Maybe<Scalars['Float']>;
};

export type MonthlyReportSummary = {
  __typename?: 'MonthlyReportSummary';
  buySellInterestAmount?: Maybe<Scalars['Float']>;
  buySellPrincipalAdvanceAmount?: Maybe<Scalars['Float']>;
  buySellPrincipalRecoupeAmount?: Maybe<Scalars['Float']>;
  moneyTransferAmount?: Maybe<Scalars['Float']>;
  moneyTransferFee?: Maybe<Scalars['Float']>;
  numberOfDays: Scalars['PositiveInt'];
  pawnInterestAmount?: Maybe<Scalars['Float']>;
  pawnPrincipalAdvanceAmount?: Maybe<Scalars['Float']>;
  pawnPrincipalRecoupeAmount?: Maybe<Scalars['Float']>;
  principalReceived?: Maybe<Scalars['Float']>;
  totalExpense?: Maybe<Scalars['Float']>;
  totalIncome?: Maybe<Scalars['Float']>;
  totalInterestAmount?: Maybe<Scalars['Float']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addRepairAmount: MutationWithValidationResponse;
  createContract: CreateContractResponse;
  createContractFiles: MutationWithValidationResponse;
  createIncomeExpense: CreateIncomeExpenseResponse;
  createInvestedPrincipal: CreateInvestedPrincipalResponse;
  createMoneyTransfer: CreateMoneyTransferResponse;
  deleteContract: MutationWithValidationResponse;
  deleteContractEvent: MutationWithValidationResponse;
  deleteContractFile: MutationWithValidationResponse;
  deleteContracts: MutationWithValidationResponse;
  deleteIncomeExpense: MutationWithValidationResponse;
  deleteIncomeExpenses: MutationWithValidationResponse;
  deleteInvestedPrincipal: MutationWithValidationResponse;
  deleteInvestedPrincipals: MutationWithValidationResponse;
  deleteMoneyTransfer: MutationWithValidationResponse;
  deleteMoneyTransfers: MutationWithValidationResponse;
  executeContract: MutationWithValidationResponse;
  extendContract: MutationWithValidationResponse;
  partialPayment: MutationWithValidationResponse;
  ping: Scalars['UnsignedInt'];
  reclaimContract: MutationWithValidationResponse;
  sellContract: MutationWithValidationResponse;
  takeMorePrincipal: MutationWithValidationResponse;
  updateAddRepairAmount: MutationWithValidationResponse;
  updateContract: MutationWithValidationResponse;
  updateContractListStatus: MutationWithValidationResponse;
  updateContractsListStatus: MutationWithValidationResponse;
  updateEndingBalanceReport: UpdateEndingBalanceReportResponse;
  updateExtendContract: MutationWithValidationResponse;
  updateIncomeExpense: MutationWithValidationResponse;
  updateInvestedPrincipal: MutationWithValidationResponse;
  updateMoneyTransfer: MutationWithValidationResponse;
  updatePartialPayment: MutationWithValidationResponse;
  updateReclaimContract: MutationWithValidationResponse;
  updateSellContract: MutationWithValidationResponse;
  updateTakeMorePrincipal: MutationWithValidationResponse;
};


export type MutationAddRepairAmountArgs = {
  contractId: Scalars['ID'];
  input: RepairProductInput;
};


export type MutationCreateContractArgs = {
  input: CreateContractInput;
};


export type MutationCreateContractFilesArgs = {
  contractId: Scalars['ID'];
  files?: InputMaybe<Array<TmpUpload>>;
};


export type MutationCreateIncomeExpenseArgs = {
  input: IncomeExpenseInput;
};


export type MutationCreateInvestedPrincipalArgs = {
  input: InvestedPrincipalInput;
};


export type MutationCreateMoneyTransferArgs = {
  input: MoneyTransferInput;
};


export type MutationDeleteContractArgs = {
  contractId: Scalars['ID'];
};


export type MutationDeleteContractEventArgs = {
  contractEventId: Scalars['ID'];
};


export type MutationDeleteContractFileArgs = {
  contractFileId: Scalars['ID'];
};


export type MutationDeleteContractsArgs = {
  contractIds: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationDeleteIncomeExpenseArgs = {
  incomeExpenseId: Scalars['ID'];
};


export type MutationDeleteIncomeExpensesArgs = {
  incomeExpenseIds: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationDeleteInvestedPrincipalArgs = {
  investedPrincipalId: Scalars['ID'];
};


export type MutationDeleteInvestedPrincipalsArgs = {
  investedPrincipalIds: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationDeleteMoneyTransferArgs = {
  moneyTransferId: Scalars['ID'];
};


export type MutationDeleteMoneyTransfersArgs = {
  moneyTransferIds: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationExecuteContractArgs = {
  contractId: Scalars['ID'];
};


export type MutationExtendContractArgs = {
  contractId: Scalars['ID'];
  input?: InputMaybe<ExtendContractInput>;
};


export type MutationPartialPaymentArgs = {
  contractId: Scalars['ID'];
  input?: InputMaybe<PartialPaymentInput>;
};


export type MutationReclaimContractArgs = {
  contractId: Scalars['ID'];
  input?: InputMaybe<ReclaimContractInput>;
};


export type MutationSellContractArgs = {
  contractId: Scalars['ID'];
  input: SellContractInput;
};


export type MutationTakeMorePrincipalArgs = {
  contractId: Scalars['ID'];
  input?: InputMaybe<TakeMorePrincipalInput>;
};


export type MutationUpdateAddRepairAmountArgs = {
  eventId: Scalars['ID'];
  input: RepairProductInput;
};


export type MutationUpdateContractArgs = {
  contractId: Scalars['ID'];
  input: UpdateContractInput;
};


export type MutationUpdateContractListStatusArgs = {
  contractId: Scalars['ID'];
  list?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateContractsListStatusArgs = {
  contractIds: Array<InputMaybe<Scalars['ID']>>;
  list: Scalars['Boolean'];
};


export type MutationUpdateEndingBalanceReportArgs = {
  dateKey: Scalars['PositiveInt'];
  endingBalance: Scalars['Float'];
};


export type MutationUpdateExtendContractArgs = {
  eventId: Scalars['ID'];
  input?: InputMaybe<ExtendContractInput>;
};


export type MutationUpdateIncomeExpenseArgs = {
  incomeExpenseId: Scalars['ID'];
  input: IncomeExpenseInput;
};


export type MutationUpdateInvestedPrincipalArgs = {
  input: InvestedPrincipalInput;
  investedPrincipalId: Scalars['ID'];
};


export type MutationUpdateMoneyTransferArgs = {
  input: MoneyTransferInput;
  moneyTransferId: Scalars['ID'];
};


export type MutationUpdatePartialPaymentArgs = {
  eventId: Scalars['ID'];
  input?: InputMaybe<PartialPaymentInput>;
};


export type MutationUpdateReclaimContractArgs = {
  eventId: Scalars['ID'];
  input?: InputMaybe<ReclaimContractInput>;
};


export type MutationUpdateSellContractArgs = {
  eventId: Scalars['ID'];
  input: SellContractInput;
};


export type MutationUpdateTakeMorePrincipalArgs = {
  eventId: Scalars['ID'];
  input?: InputMaybe<TakeMorePrincipalInput>;
};

export type MutationWithValidationResponse = {
  __typename?: 'MutationWithValidationResponse';
  code: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
  validationErrors?: Maybe<Array<FieldValidationError>>;
};

export type NumberFilterInput = {
  operatorTypeId?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<NumberFilterQueryInput>;
};

export type NumberFilterQueryInput = {
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  matches: Scalars['Int'];
  total?: Maybe<Scalars['Int']>;
};

export type PaginatedContracts = {
  __typename?: 'PaginatedContracts';
  contracts?: Maybe<Array<Contract>>;
  pageInfo: PageInfo;
  summary?: Maybe<PaginatedContractsSummary>;
};

export type PaginatedContractsSummary = {
  __typename?: 'PaginatedContractsSummary';
  expiredCount?: Maybe<Scalars['PositiveInt']>;
  totalNetAmount?: Maybe<Scalars['Float']>;
  totalPrincipalAmount?: Maybe<Scalars['PositiveFloat']>;
};

export type PaginatedIncomeExpenses = {
  __typename?: 'PaginatedIncomeExpenses';
  incomeExpenses?: Maybe<Array<IncomeExpense>>;
  pageInfo: PageInfo;
  summary?: Maybe<PaginatedIncomeExpensesSummary>;
};

export type PaginatedIncomeExpensesSummary = {
  __typename?: 'PaginatedIncomeExpensesSummary';
  totalAmount?: Maybe<Scalars['Float']>;
};

export type PaginatedInvestedPrincipals = {
  __typename?: 'PaginatedInvestedPrincipals';
  investedPrincipals?: Maybe<Array<InvestedPrincipal>>;
  pageInfo: PageInfo;
  summary?: Maybe<PaginatedInvestedPrincipalsSummary>;
};

export type PaginatedInvestedPrincipalsSummary = {
  __typename?: 'PaginatedInvestedPrincipalsSummary';
  averageInterestRate?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
};

export type PaginatedMoneyTransfers = {
  __typename?: 'PaginatedMoneyTransfers';
  moneyTransfers?: Maybe<Array<MoneyTransfer>>;
  pageInfo: PageInfo;
  summary?: Maybe<PaginatedMoneyTransfersSummary>;
};

export type PaginatedMoneyTransfersSummary = {
  __typename?: 'PaginatedMoneyTransfersSummary';
  totalAmount?: Maybe<Scalars['Float']>;
  totalFee?: Maybe<Scalars['Float']>;
};

export type PartialPaymentInput = {
  createdAt: Scalars['BigInt'];
  financialAccounts?: InputMaybe<Array<ContractFinancialAccountInput>>;
  notes?: InputMaybe<Scalars['String']>;
  paidInterestAmount: Scalars['Float'];
  paidPrincipalAmount: Scalars['Float'];
  partyName?: InputMaybe<Scalars['String']>;
};

export type PeriodReport = {
  __typename?: 'PeriodReport';
  buySellInterestAmount: Scalars['Float'];
  buySellPrincipalAdvanceAmount: Scalars['Float'];
  buySellPrincipalRecoupeAmount: Scalars['Float'];
  byFinancialAccounts?: Maybe<Array<PeriodReportByFinancialAccount>>;
  incomeExpenseExpense: Scalars['Float'];
  incomeExpenseIncome: Scalars['Float'];
  investedPrincipalReceivedAmount: Scalars['Float'];
  investedPrincipalRepaidAmount: Scalars['Float'];
  moneyTransferAmount: Scalars['Float'];
  moneyTransferFee: Scalars['Float'];
  pawnInterestAmount: Scalars['Float'];
  pawnPrincipalAdvanceAmount: Scalars['Float'];
  pawnPrincipalRecoupeAmount: Scalars['Float'];
};

export type PeriodReportByFinancialAccount = {
  __typename?: 'PeriodReportByFinancialAccount';
  beginingBalance: Scalars['Float'];
  companyFinancialAccountId: Scalars['ID'];
  endingBalance: Scalars['Float'];
  expense: Scalars['Float'];
  id: Scalars['ID'];
  income: Scalars['Float'];
  services?: Maybe<Array<PeriodReportByFinancialAccountService>>;
};

export type PeriodReportByFinancialAccountService = {
  __typename?: 'PeriodReportByFinancialAccountService';
  expense: Scalars['Float'];
  id: Scalars['ID'];
  income: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  exportDailyReport: ExportReportResponse;
  exportMonthlyReport: ExportReportResponse;
  getAllCompanyProductCategories?: Maybe<Array<CompanyProductCategory>>;
  getConfiguration: Config;
  getContract?: Maybe<Contract>;
  getContractFileDownloadUrl?: Maybe<Scalars['String']>;
  getCurrentCompany?: Maybe<Company>;
  getCurrentShop?: Maybe<Shop>;
  getCurrentShopCompanyFinancialAccounts?: Maybe<Array<CompanyFinancialAccount>>;
  getCurrentUser?: Maybe<User>;
  getDailyReport: GetDailyReportResponse;
  getFinancialAccountTypes?: Maybe<Array<FinancialAccountType>>;
  getIncomeExpense?: Maybe<IncomeExpense>;
  getInvestedPrincipal?: Maybe<InvestedPrincipal>;
  getInvestedPrincipalReport: Array<Maybe<GetInvestedPrincipalReportResponse>>;
  getMoneyTransfer?: Maybe<MoneyTransfer>;
  getMonthlyReport: GetMonthlyReportResponse;
  getNextContractWithinDayId: Scalars['String'];
  getPaginatedContracts: PaginatedContracts;
  getPaginatedIncomeExpenses: PaginatedIncomeExpenses;
  getPaginatedInvestedPrincipals: PaginatedInvestedPrincipals;
  getPaginatedMoneyTransfers: PaginatedMoneyTransfers;
  getPeriodReport: GetPeriodReportResponse;
  getShopInvestors?: Maybe<Array<ShopInvestor>>;
};


export type QueryExportDailyReportArgs = {
  dateKey: Scalars['PositiveInt'];
};


export type QueryExportMonthlyReportArgs = {
  monthKey: Scalars['PositiveInt'];
};


export type QueryGetContractArgs = {
  id: Scalars['ID'];
};


export type QueryGetContractFileDownloadUrlArgs = {
  contractFileId: Scalars['ID'];
};


export type QueryGetDailyReportArgs = {
  dateKey: Scalars['PositiveInt'];
};


export type QueryGetIncomeExpenseArgs = {
  id: Scalars['ID'];
};


export type QueryGetInvestedPrincipalArgs = {
  id: Scalars['ID'];
};


export type QueryGetMoneyTransferArgs = {
  id: Scalars['ID'];
};


export type QueryGetMonthlyReportArgs = {
  monthKey: Scalars['PositiveInt'];
};


export type QueryGetNextContractWithinDayIdArgs = {
  writtenDate: Scalars['BigInt'];
};


export type QueryGetPaginatedContractsArgs = {
  filters?: InputMaybe<ContractFilterInput>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['UnsignedInt']>;
  rowsPerPage?: InputMaybe<Scalars['UnsignedInt']>;
};


export type QueryGetPaginatedIncomeExpensesArgs = {
  filters?: InputMaybe<IncomeExpenseFilterInput>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['UnsignedInt']>;
  rowsPerPage?: InputMaybe<Scalars['UnsignedInt']>;
};


export type QueryGetPaginatedInvestedPrincipalsArgs = {
  filters?: InputMaybe<InvestedPrincipalFilterInput>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['UnsignedInt']>;
  rowsPerPage?: InputMaybe<Scalars['UnsignedInt']>;
};


export type QueryGetPaginatedMoneyTransfersArgs = {
  filters?: InputMaybe<MoneyTransferFilterInput>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['UnsignedInt']>;
  rowsPerPage?: InputMaybe<Scalars['UnsignedInt']>;
};


export type QueryGetPeriodReportArgs = {
  dateKey: Scalars['PositiveInt'];
};

export type ReclaimContractInput = {
  amount: Scalars['Float'];
  createdAt: Scalars['BigInt'];
  financialAccounts?: InputMaybe<Array<ContractFinancialAccountInput>>;
  interestAmount: Scalars['Float'];
  notes?: InputMaybe<Scalars['String']>;
  partyName?: InputMaybe<Scalars['String']>;
};

export type RepairProductInput = {
  createdAt: Scalars['BigInt'];
  financialAccounts?: InputMaybe<Array<ContractFinancialAccountInput>>;
  notes?: InputMaybe<Scalars['String']>;
  partyName?: InputMaybe<Scalars['String']>;
  repairAmount: Scalars['Float'];
};

export type SellContractInput = {
  createdAt: Scalars['BigInt'];
  financialAccounts?: InputMaybe<Array<ContractFinancialAccountInput>>;
  notes?: InputMaybe<Scalars['String']>;
  partyName?: InputMaybe<Scalars['String']>;
  soldAmount: Scalars['Float'];
};

export type Shop = {
  __typename?: 'Shop';
  companyId: Scalars['ID'];
  contractPrintSettings?: Maybe<ShopContractPrintSettings>;
  domain?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ShopContractPrintSettings = {
  __typename?: 'ShopContractPrintSettings';
  id: Scalars['ID'];
  leftAreaLine1?: Maybe<Scalars['String']>;
  leftAreaLine2?: Maybe<Scalars['String']>;
  leftAreaLine3?: Maybe<Scalars['String']>;
  leftAreaLine4?: Maybe<Scalars['String']>;
  showPrintTimestamp: Scalars['Boolean'];
  signingPlaceName?: Maybe<Scalars['String']>;
};

export type ShopInvestor = {
  __typename?: 'ShopInvestor';
  avatarUrl?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  interestRate: Scalars['Float'];
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
};

export type TakeMorePrincipalInput = {
  additionalPrincipalAmount: Scalars['Float'];
  createdAt: Scalars['BigInt'];
  customerOwedInterestAmount: Scalars['Float'];
  financialAccounts?: InputMaybe<Array<ContractFinancialAccountInput>>;
  notes?: InputMaybe<Scalars['String']>;
  partyName?: InputMaybe<Scalars['String']>;
};

export type TmpUpload = {
  fileName: Scalars['String'];
  tmpFilePath: Scalars['String'];
};

export type UpdateContractInput = {
  companyProductCategoryId: Scalars['ID'];
  customerAddress?: InputMaybe<Scalars['String']>;
  customerName: Scalars['String'];
  customerPhone: Scalars['String'];
  engineCode?: InputMaybe<Scalars['String']>;
  financialAccounts?: InputMaybe<Array<ContractFinancialAccountInput>>;
  frameCode?: InputMaybe<Scalars['String']>;
  itemDescription: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  numberOfPawnDays: Scalars['UnsignedInt'];
  plateNumber?: InputMaybe<Scalars['String']>;
  principalAmount: Scalars['UnsignedFloat'];
};

export type UpdateEndingBalanceReportResponse = {
  __typename?: 'UpdateEndingBalanceReportResponse';
  code: Scalars['Int'];
};

export type User = {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isContractBackDateable?: Maybe<Scalars['Boolean']>;
  isContractCreatable?: Maybe<Scalars['Boolean']>;
  isIncomeExpenseCreatable?: Maybe<Scalars['Boolean']>;
  isInvestedPrincipalCreatable?: Maybe<Scalars['Boolean']>;
  isMoneyTransferCreatable?: Maybe<Scalars['Boolean']>;
  isPrivateStatisticViewable?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  roleId?: Maybe<Scalars['ID']>;
  shops?: Maybe<Array<Shop>>;
  uid: Scalars['String'];
};

export type GetAllCompanyProductCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCompanyProductCategoriesQuery = { __typename?: 'Query', getAllCompanyProductCategories?: Array<{ __typename?: 'CompanyProductCategory', id: string, name: string }> | null };

export type GetShopInvestorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShopInvestorsQuery = { __typename?: 'Query', getShopInvestors?: Array<{ __typename?: 'ShopInvestor', id: string, name: string }> | null };

export type GetConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigurationQuery = { __typename?: 'Query', getConfiguration: { __typename?: 'Config', isDevelopment: boolean, isAutomationAllowed: boolean, toastAutoHideDuration: any, isSystemInMaintenanceMode: boolean, isPushNotificationEnabled: boolean, isTourEntriesAllowed: boolean, version: string, buildNumber: string, defaultPaginationRowsPerPage: Array<any | null> }, getCurrentCompany?: { __typename?: 'Company', id: string, name: string, domain: string } | null, getCurrentShop?: { __typename?: 'Shop', id: string, name: string } | null, getCurrentUser?: { __typename?: 'User', id?: string | null, uid: string, roleId?: string | null, isContractCreatable?: boolean | null, isContractBackDateable?: boolean | null, isPrivateStatisticViewable?: boolean | null, name?: string | null, avatarUrl?: string | null, isMoneyTransferCreatable?: boolean | null, isIncomeExpenseCreatable?: boolean | null, isInvestedPrincipalCreatable?: boolean | null, shops?: Array<{ __typename?: 'Shop', id: string, name: string, domain?: string | null }> | null } | null };

export type CreateContractMutationVariables = Exact<{
  input: CreateContractInput;
}>;


export type CreateContractMutation = { __typename?: 'Mutation', createContract: { __typename?: 'CreateContractResponse', result: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, reason: string }> | null }, contract?: { __typename?: 'Contract', id: string } | null } };

export type GetInitialDataForContractNewQueryVariables = Exact<{
  writtenDate: Scalars['BigInt'];
}>;


export type GetInitialDataForContractNewQuery = { __typename?: 'Query', getNextContractWithinDayId: string };

export type GetInitialDataForContractPrintQueryVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type GetInitialDataForContractPrintQuery = { __typename?: 'Query', getAllCompanyProductCategories?: Array<{ __typename?: 'CompanyProductCategory', id: string, name: string }> | null, getCurrentShopCompanyFinancialAccounts?: Array<{ __typename?: 'CompanyFinancialAccount', id: string, name?: string | null, financialAccountTypeId: string }> | null, getFinancialAccountTypes?: Array<{ __typename?: 'FinancialAccountType', id: string, name: string }> | null, getCurrentShop?: { __typename?: 'Shop', id: string, name: string, contractPrintSettings?: { __typename?: 'ShopContractPrintSettings', id: string, leftAreaLine1?: string | null, leftAreaLine2?: string | null, leftAreaLine3?: string | null, leftAreaLine4?: string | null, signingPlaceName?: string | null, showPrintTimestamp: boolean } | null } | null, getContract?: { __typename?: 'Contract', id: string, writtenDate?: any | null, companyProductCategoryId?: string | null, customerName?: string | null, customerAddress?: string | null, customerPhone?: string | null, itemDescription?: string | null, principalAmount: any, numberOfPawnDays?: any | null, lastExpirationDate?: any | null, frameCode?: string | null, engineCode?: string | null, plateNumber?: string | null, financialAccounts?: Array<{ __typename?: 'ContractFinancialAccount', id: string, companyFinancialAccountId: string, amount?: number | null }> | null } | null };

export type DeleteContractEventMutationVariables = Exact<{
  contractEventId: Scalars['ID'];
}>;


export type DeleteContractEventMutation = { __typename?: 'Mutation', deleteContractEvent: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null } };

export type CreateContractFilesMutationVariables = Exact<{
  contractId: Scalars['ID'];
  files?: InputMaybe<Array<TmpUpload> | TmpUpload>;
}>;


export type CreateContractFilesMutation = { __typename?: 'Mutation', createContractFiles: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null } };

export type DeleteContractFileMutationVariables = Exact<{
  contractFileId: Scalars['ID'];
}>;


export type DeleteContractFileMutation = { __typename?: 'Mutation', deleteContractFile: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null } };

export type GetContractFileDownloadUrlQueryVariables = Exact<{
  contractFileId: Scalars['ID'];
}>;


export type GetContractFileDownloadUrlQuery = { __typename?: 'Query', getContractFileDownloadUrl?: string | null };

export type UpdateContractMutationVariables = Exact<{
  contractId: Scalars['ID'];
  input: UpdateContractInput;
}>;


export type UpdateContractMutation = { __typename?: 'Mutation', updateContract: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null } };

export type DeleteContractMutationVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type DeleteContractMutation = { __typename?: 'Mutation', deleteContract: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type ExecuteContractMutationVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type ExecuteContractMutation = { __typename?: 'Mutation', executeContract: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type UpdateContractListStatusMutationVariables = Exact<{
  contractId: Scalars['ID'];
  list: Scalars['Boolean'];
}>;


export type UpdateContractListStatusMutation = { __typename?: 'Mutation', updateContractListStatus: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type ExtendContractMutationVariables = Exact<{
  contractId: Scalars['ID'];
  input: ExtendContractInput;
}>;


export type ExtendContractMutation = { __typename?: 'Mutation', extendContract: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type UpdateExtendContractMutationVariables = Exact<{
  eventId: Scalars['ID'];
  input: ExtendContractInput;
}>;


export type UpdateExtendContractMutation = { __typename?: 'Mutation', updateExtendContract: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type PartialPaymentMutationVariables = Exact<{
  contractId: Scalars['ID'];
  input: PartialPaymentInput;
}>;


export type PartialPaymentMutation = { __typename?: 'Mutation', partialPayment: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type UpdatePartialPaymentMutationVariables = Exact<{
  eventId: Scalars['ID'];
  input: PartialPaymentInput;
}>;


export type UpdatePartialPaymentMutation = { __typename?: 'Mutation', updatePartialPayment: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type ReclaimContractMutationVariables = Exact<{
  contractId: Scalars['ID'];
  input: ReclaimContractInput;
}>;


export type ReclaimContractMutation = { __typename?: 'Mutation', reclaimContract: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type UpdateReclaimContractMutationVariables = Exact<{
  eventId: Scalars['ID'];
  input: ReclaimContractInput;
}>;


export type UpdateReclaimContractMutation = { __typename?: 'Mutation', updateReclaimContract: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type AddRepairAmountMutationVariables = Exact<{
  contractId: Scalars['ID'];
  input: RepairProductInput;
}>;


export type AddRepairAmountMutation = { __typename?: 'Mutation', addRepairAmount: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type UpdateAddRepairAmountMutationVariables = Exact<{
  eventId: Scalars['ID'];
  input: RepairProductInput;
}>;


export type UpdateAddRepairAmountMutation = { __typename?: 'Mutation', updateAddRepairAmount: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type SellContractMutationVariables = Exact<{
  contractId: Scalars['ID'];
  input: SellContractInput;
}>;


export type SellContractMutation = { __typename?: 'Mutation', sellContract: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type UpdateSellContractMutationVariables = Exact<{
  eventId: Scalars['ID'];
  input: SellContractInput;
}>;


export type UpdateSellContractMutation = { __typename?: 'Mutation', updateSellContract: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type TakeMorePrincipalMutationVariables = Exact<{
  contractId: Scalars['ID'];
  input: TakeMorePrincipalInput;
}>;


export type TakeMorePrincipalMutation = { __typename?: 'Mutation', takeMorePrincipal: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type UpdateTakeMorePrincipalMutationVariables = Exact<{
  eventId: Scalars['ID'];
  input: TakeMorePrincipalInput;
}>;


export type UpdateTakeMorePrincipalMutation = { __typename?: 'Mutation', updateTakeMorePrincipal: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type GetContractQueryVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type GetContractQuery = { __typename?: 'Query', getContract?: { __typename?: 'Contract', id: string, writtenDate?: any | null, isExpired?: boolean | null, numberOfDaysToLastExpirationDate?: number | null, companyProductCategoryId?: string | null, customerName?: string | null, customerPhone?: string | null, customerAddress?: string | null, itemDescription?: string | null, notes?: string | null, principalAmount: any, repairAmount?: any | null, numberOfPawnDays?: any | null, expirationDate?: any | null, lastExpirationDate?: any | null, lastPrincipalAmount?: number | null, lastInterestStartingFromDate?: any | null, balanceAmount?: number | null, status: string, frameCode?: string | null, engineCode?: string | null, plateNumber?: string | null, withinDayId: string, netAmount?: number | null, updatedAt?: any | null, isDraftUpdatable?: boolean | null, isEffectiveUpdatable?: boolean | null, isExecutable?: boolean | null, isExtendable?: boolean | null, isDeletable?: boolean | null, isReclaimable?: boolean | null, isListable?: boolean | null, isSellable?: boolean | null, isMorePrincipalRequestable?: boolean | null, isPartialPaymentable?: boolean | null, isRepairAddable?: boolean | null, isFileCreatable?: boolean | null, isPawnTransaction: boolean, isPrintable?: boolean | null, updatedBy?: { __typename?: 'BasicUser', id: string, name: string } | null, financialAccounts?: Array<{ __typename?: 'ContractFinancialAccount', id: string, companyFinancialAccountId: string, amount?: number | null }> | null, events?: Array<{ __typename?: 'ContractEvent', id: string, type: string, createdAt: any, interestAmount?: number | null, soldAmount?: number | null, partyName?: string | null, notes?: string | null, numberOfDays?: number | null, expirationDate?: any | null, principalAmount?: number | null, repairAmount?: number | null, additionalPrincipalAmount?: number | null, customerOwedInterestAmount?: number | null, previousPrincipalAmount?: number | null, balanceAmount?: number | null, previousBalanceAmount?: number | null, amount?: number | null, createdBy: { __typename?: 'BasicUser', id: string, name: string }, financialAccounts?: Array<{ __typename?: 'ContractFinancialAccount', id: string, companyFinancialAccountId: string, amount?: number | null }> | null }> | null, files?: Array<{ __typename?: 'ContractFile', id: string, name: string, description?: string | null, category?: string | null, mimeType: string, size: any, createdAt?: any | null, isUpdatable?: boolean | null, isDeletable?: boolean | null }> | null } | null };

export type GetInitialDataForContractViewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInitialDataForContractViewQuery = { __typename?: 'Query', getAllCompanyProductCategories?: Array<{ __typename?: 'CompanyProductCategory', id: string, name: string, defaultRequiredExtensionInDays: number, isDefault: boolean }> | null, getCurrentShopCompanyFinancialAccounts?: Array<{ __typename?: 'CompanyFinancialAccount', id: string, name?: string | null, isDefault: boolean, financialAccountTypeId: string }> | null, getFinancialAccountTypes?: Array<{ __typename?: 'FinancialAccountType', id: string, name: string }> | null };

export type GetPeriodReportQueryVariables = Exact<{
  dateKey: Scalars['PositiveInt'];
}>;


export type GetPeriodReportQuery = { __typename?: 'Query', getCurrentShopCompanyFinancialAccounts?: Array<{ __typename?: 'CompanyFinancialAccount', id: string, name?: string | null, financialAccountTypeId: string, isDefault: boolean }> | null, getFinancialAccountTypes?: Array<{ __typename?: 'FinancialAccountType', id: string, name: string }> | null, getPeriodReport: { __typename?: 'GetPeriodReportResponse', result: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null }, periodReport?: { __typename?: 'PeriodReport', pawnPrincipalAdvanceAmount: number, pawnPrincipalRecoupeAmount: number, pawnInterestAmount: number, buySellPrincipalAdvanceAmount: number, buySellPrincipalRecoupeAmount: number, buySellInterestAmount: number, moneyTransferAmount: number, moneyTransferFee: number, incomeExpenseExpense: number, incomeExpenseIncome: number, investedPrincipalReceivedAmount: number, investedPrincipalRepaidAmount: number, byFinancialAccounts?: Array<{ __typename?: 'PeriodReportByFinancialAccount', id: string, companyFinancialAccountId: string, beginingBalance: number, endingBalance: number, income: number, expense: number, services?: Array<{ __typename?: 'PeriodReportByFinancialAccountService', id: string, income: number, expense: number }> | null }> | null } | null } };

export type GetIncomeExpenseForEditQueryVariables = Exact<{
  incomeExpenseId: Scalars['ID'];
}>;


export type GetIncomeExpenseForEditQuery = { __typename?: 'Query', getIncomeExpense?: { __typename?: 'IncomeExpense', id: string, transactionDate: any, amount: number, notes: string, createdAt?: any | null, updatedAt?: any | null, companyFinancialAccountId: string, isUpdatable?: boolean | null, isDeletable?: boolean | null, createdBy?: { __typename?: 'BasicUser', id: string, name: string } | null, updatedBy?: { __typename?: 'BasicUser', id: string, name: string } | null } | null, getCurrentShopCompanyFinancialAccounts?: Array<{ __typename?: 'CompanyFinancialAccount', id: string, name?: string | null, financialAccountTypeId: string, isDefault: boolean }> | null, getFinancialAccountTypes?: Array<{ __typename?: 'FinancialAccountType', id: string, name: string }> | null };

export type UpdateIncomeExpenseMutationVariables = Exact<{
  incomeExpenseId: Scalars['ID'];
  input: IncomeExpenseInput;
}>;


export type UpdateIncomeExpenseMutation = { __typename?: 'Mutation', updateIncomeExpense: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type DeleteIncomeExpensesMutationVariables = Exact<{
  incomeExpenseIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type DeleteIncomeExpensesMutation = { __typename?: 'Mutation', deleteIncomeExpenses: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null } };

export type GetInitialDataForIncomeExpenseListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInitialDataForIncomeExpenseListQuery = { __typename?: 'Query', getCurrentShopCompanyFinancialAccounts?: Array<{ __typename?: 'CompanyFinancialAccount', id: string, name?: string | null, financialAccountTypeId: string, isDefault: boolean }> | null, getFinancialAccountTypes?: Array<{ __typename?: 'FinancialAccountType', id: string, name: string }> | null };

export type GetPaginatedIncomeExpensesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['UnsignedInt']>;
  rowsPerPage?: InputMaybe<Scalars['UnsignedInt']>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<IncomeExpenseFilterInput>;
}>;


export type GetPaginatedIncomeExpensesQuery = { __typename?: 'Query', getPaginatedIncomeExpenses: { __typename?: 'PaginatedIncomeExpenses', pageInfo: { __typename?: 'PageInfo', total?: number | null, matches: number }, incomeExpenses?: Array<{ __typename?: 'IncomeExpense', id: string, createdAt?: any | null, transactionDate: any, companyFinancialAccountId: string, amount: number, notes: string, isDeletable?: boolean | null, createdBy?: { __typename?: 'BasicUser', id: string, name: string } | null }> | null, summary?: { __typename?: 'PaginatedIncomeExpensesSummary', totalAmount?: number | null } | null } };

export type CreateIncomeExpenseMutationVariables = Exact<{
  input: IncomeExpenseInput;
}>;


export type CreateIncomeExpenseMutation = { __typename?: 'Mutation', createIncomeExpense: { __typename?: 'CreateIncomeExpenseResponse', result: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null }, incomeExpense?: { __typename?: 'IncomeExpense', id: string } | null } };

export type GetInitialDataForIncomeExpenseNewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInitialDataForIncomeExpenseNewQuery = { __typename?: 'Query', getCurrentShopCompanyFinancialAccounts?: Array<{ __typename?: 'CompanyFinancialAccount', id: string, name?: string | null, financialAccountTypeId: string, isDefault: boolean }> | null, getFinancialAccountTypes?: Array<{ __typename?: 'FinancialAccountType', id: string, name: string }> | null };

export type DeleteIncomeExpenseMutationVariables = Exact<{
  incomeExpenseId: Scalars['ID'];
}>;


export type DeleteIncomeExpenseMutation = { __typename?: 'Mutation', deleteIncomeExpense: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type GetIncomeExpenseForViewQueryVariables = Exact<{
  incomeExpenseId: Scalars['ID'];
}>;


export type GetIncomeExpenseForViewQuery = { __typename?: 'Query', getIncomeExpense?: { __typename?: 'IncomeExpense', id: string, transactionDate: any, amount: number, companyFinancialAccountId: string, notes: string, createdAt?: any | null, updatedAt?: any | null, isUpdatable?: boolean | null, isDeletable?: boolean | null, createdBy?: { __typename?: 'BasicUser', id: string, name: string } | null, updatedBy?: { __typename?: 'BasicUser', id: string, name: string } | null } | null, getCurrentShopCompanyFinancialAccounts?: Array<{ __typename?: 'CompanyFinancialAccount', id: string, name?: string | null, financialAccountTypeId: string, isDefault: boolean }> | null, getFinancialAccountTypes?: Array<{ __typename?: 'FinancialAccountType', id: string, name: string }> | null };

export type GetInvestedPrincipalForEditQueryVariables = Exact<{
  investedPrincipalId: Scalars['ID'];
}>;


export type GetInvestedPrincipalForEditQuery = { __typename?: 'Query', getInvestedPrincipal?: { __typename?: 'InvestedPrincipal', id: string, transactionDate: any, amount: number, companyFinancialAccountId: string, notes?: string | null, createdAt?: any | null, updatedAt?: any | null, interestRate: number, isUpdatable?: boolean | null, isDeletable?: boolean | null, investorUserId: string, investor?: { __typename?: 'BasicUser', id: string, name: string } | null, createdBy?: { __typename?: 'BasicUser', id: string, name: string } | null, updatedBy?: { __typename?: 'BasicUser', id: string, name: string } | null } | null, getCurrentShopCompanyFinancialAccounts?: Array<{ __typename?: 'CompanyFinancialAccount', id: string, name?: string | null, financialAccountTypeId: string, isDefault: boolean }> | null, getFinancialAccountTypes?: Array<{ __typename?: 'FinancialAccountType', id: string, name: string }> | null, getShopInvestors?: Array<{ __typename?: 'ShopInvestor', id: string, name: string, interestRate: number }> | null };

export type UpdateInvestedPrincipalMutationVariables = Exact<{
  investedPrincipalId: Scalars['ID'];
  input: InvestedPrincipalInput;
}>;


export type UpdateInvestedPrincipalMutation = { __typename?: 'Mutation', updateInvestedPrincipal: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type DeleteInvestedPrincipalsMutationVariables = Exact<{
  investedPrincipalIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type DeleteInvestedPrincipalsMutation = { __typename?: 'Mutation', deleteInvestedPrincipals: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null } };

export type GetInitialDataForInvestedPrincipalListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInitialDataForInvestedPrincipalListQuery = { __typename?: 'Query', getCurrentShopCompanyFinancialAccounts?: Array<{ __typename?: 'CompanyFinancialAccount', id: string, name?: string | null, financialAccountTypeId: string, isDefault: boolean }> | null, getFinancialAccountTypes?: Array<{ __typename?: 'FinancialAccountType', id: string, name: string }> | null };

export type GetPaginatedInvestedPrincipalsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['UnsignedInt']>;
  rowsPerPage?: InputMaybe<Scalars['UnsignedInt']>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<InvestedPrincipalFilterInput>;
}>;


export type GetPaginatedInvestedPrincipalsQuery = { __typename?: 'Query', getPaginatedInvestedPrincipals: { __typename?: 'PaginatedInvestedPrincipals', pageInfo: { __typename?: 'PageInfo', total?: number | null, matches: number }, investedPrincipals?: Array<{ __typename?: 'InvestedPrincipal', id: string, createdAt?: any | null, transactionDate: any, companyFinancialAccountId: string, amount: number, interestRate: number, isDeletable?: boolean | null, investorUserId: string, createdBy?: { __typename?: 'BasicUser', id: string, name: string } | null, investor?: { __typename?: 'BasicUser', id: string, name: string } | null }> | null, summary?: { __typename?: 'PaginatedInvestedPrincipalsSummary', totalAmount?: number | null, averageInterestRate?: number | null } | null } };

export type CreateInvestedPrincipalMutationVariables = Exact<{
  input: InvestedPrincipalInput;
}>;


export type CreateInvestedPrincipalMutation = { __typename?: 'Mutation', createInvestedPrincipal: { __typename?: 'CreateInvestedPrincipalResponse', result: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null }, investedPrincipal?: { __typename?: 'InvestedPrincipal', id: string } | null } };

export type GetInitialDataForInvestedPrincipalNewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInitialDataForInvestedPrincipalNewQuery = { __typename?: 'Query', getCurrentShopCompanyFinancialAccounts?: Array<{ __typename?: 'CompanyFinancialAccount', id: string, name?: string | null, financialAccountTypeId: string, isDefault: boolean }> | null, getFinancialAccountTypes?: Array<{ __typename?: 'FinancialAccountType', id: string, name: string }> | null, getShopInvestors?: Array<{ __typename?: 'ShopInvestor', id: string, name: string, interestRate: number }> | null };

export type DeleteInvestedPrincipalMutationVariables = Exact<{
  investedPrincipalId: Scalars['ID'];
}>;


export type DeleteInvestedPrincipalMutation = { __typename?: 'Mutation', deleteInvestedPrincipal: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type GetInvestedPrincipalForViewQueryVariables = Exact<{
  investedPrincipalId: Scalars['ID'];
}>;


export type GetInvestedPrincipalForViewQuery = { __typename?: 'Query', getInvestedPrincipal?: { __typename?: 'InvestedPrincipal', id: string, transactionDate: any, amount: number, companyFinancialAccountId: string, notes?: string | null, interestRate: number, createdAt?: any | null, updatedAt?: any | null, isUpdatable?: boolean | null, isDeletable?: boolean | null, investor?: { __typename?: 'BasicUser', id: string, name: string } | null, createdBy?: { __typename?: 'BasicUser', id: string, name: string } | null, updatedBy?: { __typename?: 'BasicUser', id: string, name: string } | null } | null, getCurrentShopCompanyFinancialAccounts?: Array<{ __typename?: 'CompanyFinancialAccount', id: string, name?: string | null, financialAccountTypeId: string, isDefault: boolean }> | null, getFinancialAccountTypes?: Array<{ __typename?: 'FinancialAccountType', id: string, name: string }> | null };

export type GetMoneyTransferForEditQueryVariables = Exact<{
  moneyTransferId: Scalars['ID'];
}>;


export type GetMoneyTransferForEditQuery = { __typename?: 'Query', getMoneyTransfer?: { __typename?: 'MoneyTransfer', id: string, transferredDate: any, amount: number, fromCompanyFinancialAccountId: string, customerName?: string | null, notes?: string | null, createdAt?: any | null, updatedAt?: any | null, fee: number, toCompanyFinancialAccountId: string, isUpdatable?: boolean | null, isDeletable?: boolean | null, createdBy?: { __typename?: 'BasicUser', id: string, name: string } | null, updatedBy?: { __typename?: 'BasicUser', id: string, name: string } | null } | null, getCurrentShopCompanyFinancialAccounts?: Array<{ __typename?: 'CompanyFinancialAccount', id: string, name?: string | null, financialAccountTypeId: string, isDefault: boolean }> | null, getFinancialAccountTypes?: Array<{ __typename?: 'FinancialAccountType', id: string, name: string }> | null };

export type UpdateMoneyTransferMutationVariables = Exact<{
  moneyTransferId: Scalars['ID'];
  input: MoneyTransferInput;
}>;


export type UpdateMoneyTransferMutation = { __typename?: 'Mutation', updateMoneyTransfer: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type DeleteMoneyTransfersMutationVariables = Exact<{
  moneyTransferIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type DeleteMoneyTransfersMutation = { __typename?: 'Mutation', deleteMoneyTransfers: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null } };

export type GetInitialDataForMoneyTransferListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInitialDataForMoneyTransferListQuery = { __typename?: 'Query', getCurrentShopCompanyFinancialAccounts?: Array<{ __typename?: 'CompanyFinancialAccount', id: string, name?: string | null, financialAccountTypeId: string, isDefault: boolean }> | null, getFinancialAccountTypes?: Array<{ __typename?: 'FinancialAccountType', id: string, name: string }> | null };

export type GetPaginatedMoneyTransfersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['UnsignedInt']>;
  rowsPerPage?: InputMaybe<Scalars['UnsignedInt']>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<MoneyTransferFilterInput>;
}>;


export type GetPaginatedMoneyTransfersQuery = { __typename?: 'Query', getPaginatedMoneyTransfers: { __typename?: 'PaginatedMoneyTransfers', pageInfo: { __typename?: 'PageInfo', total?: number | null, matches: number }, moneyTransfers?: Array<{ __typename?: 'MoneyTransfer', id: string, createdAt?: any | null, transferredDate: any, customerName?: string | null, fromCompanyFinancialAccountId: string, amount: number, fee: number, toCompanyFinancialAccountId: string, isDeletable?: boolean | null, createdBy?: { __typename?: 'BasicUser', id: string, name: string } | null }> | null, summary?: { __typename?: 'PaginatedMoneyTransfersSummary', totalAmount?: number | null, totalFee?: number | null } | null } };

export type CreateMoneyTransferMutationVariables = Exact<{
  input: MoneyTransferInput;
}>;


export type CreateMoneyTransferMutation = { __typename?: 'Mutation', createMoneyTransfer: { __typename?: 'CreateMoneyTransferResponse', result: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null }, moneyTransfer?: { __typename?: 'MoneyTransfer', id: string } | null } };

export type GetInitialDataForMoneyTransferNewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInitialDataForMoneyTransferNewQuery = { __typename?: 'Query', getCurrentShopCompanyFinancialAccounts?: Array<{ __typename?: 'CompanyFinancialAccount', id: string, name?: string | null, financialAccountTypeId: string, isDefault: boolean }> | null, getFinancialAccountTypes?: Array<{ __typename?: 'FinancialAccountType', id: string, name: string }> | null };

export type DeleteMoneyTransferMutationVariables = Exact<{
  moneyTransferId: Scalars['ID'];
}>;


export type DeleteMoneyTransferMutation = { __typename?: 'Mutation', deleteMoneyTransfer: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type GetMoneyTransferForViewQueryVariables = Exact<{
  moneyTransferId: Scalars['ID'];
}>;


export type GetMoneyTransferForViewQuery = { __typename?: 'Query', getMoneyTransfer?: { __typename?: 'MoneyTransfer', id: string, transferredDate: any, amount: number, fromCompanyFinancialAccountId: string, customerName?: string | null, notes?: string | null, fee: number, toCompanyFinancialAccountId: string, createdAt?: any | null, updatedAt?: any | null, isUpdatable?: boolean | null, isDeletable?: boolean | null, createdBy?: { __typename?: 'BasicUser', id: string, name: string } | null, updatedBy?: { __typename?: 'BasicUser', id: string, name: string } | null } | null, getCurrentShopCompanyFinancialAccounts?: Array<{ __typename?: 'CompanyFinancialAccount', id: string, name?: string | null, financialAccountTypeId: string, isDefault: boolean }> | null, getFinancialAccountTypes?: Array<{ __typename?: 'FinancialAccountType', id: string, name: string }> | null };

export type DeleteContractsMutationVariables = Exact<{
  contractIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type DeleteContractsMutation = { __typename?: 'Mutation', deleteContracts: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type UpdateContractsListStatusMutationVariables = Exact<{
  contractIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  list: Scalars['Boolean'];
}>;


export type UpdateContractsListStatusMutation = { __typename?: 'Mutation', updateContractsListStatus: { __typename?: 'MutationWithValidationResponse', code: number, message?: string | null, validationErrors?: Array<{ __typename?: 'FieldValidationError', field: string, code: string, reason: string }> | null } };

export type GetInitialDataForContractListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInitialDataForContractListQuery = { __typename?: 'Query', getAllCompanyProductCategories?: Array<{ __typename?: 'CompanyProductCategory', id: string, name: string }> | null };

export type GetPaginatedContractsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['UnsignedInt']>;
  rowsPerPage?: InputMaybe<Scalars['UnsignedInt']>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ContractFilterInput>;
}>;


export type GetPaginatedContractsQuery = { __typename?: 'Query', getPaginatedContracts: { __typename?: 'PaginatedContracts', pageInfo: { __typename?: 'PageInfo', total?: number | null, matches: number }, contracts?: Array<{ __typename?: 'Contract', id: string, writtenDate?: any | null, customerName?: string | null, customerPhone?: string | null, companyProductCategoryId?: string | null, itemDescription?: string | null, principalAmount: any, lastInterestStartingFromDate?: any | null, status: string, isExpired?: boolean | null, numberOfDaysToLastExpirationDate?: number | null, netAmount?: number | null, isCompleted?: boolean | null, isListable?: boolean | null, isDeletable?: boolean | null, withinDayId: string, isPawnTransaction: boolean, lastPrincipalAmount?: number | null }> | null, summary?: { __typename?: 'PaginatedContractsSummary', totalPrincipalAmount?: any | null, totalNetAmount?: number | null, expiredCount?: any | null } | null } };

export type ExportDailyReportQueryVariables = Exact<{
  dateKey: Scalars['PositiveInt'];
}>;


export type ExportDailyReportQuery = { __typename?: 'Query', exportDailyReport: { __typename?: 'ExportReportResponse', code: number, downloadableUrl: any } };

export type GetDailyReportQueryVariables = Exact<{
  dateKey: Scalars['PositiveInt'];
}>;


export type GetDailyReportQuery = { __typename?: 'Query', getDailyReport: { __typename?: 'GetDailyReportResponse', dateKey: any, transactions?: Array<{ __typename?: 'DailyReportTransaction', id: string, transactionId: string, description: string, timestamp: any, serviceName: string, amount?: number | null, pawnPrincipalAmount?: number | null, pawnInterestAmount?: number | null, buySellPrincipalAmount?: number | null, buySellInterestAmount?: number | null, moneyTransferCashInAmount?: number | null, moneyTransferCashOutAmount?: number | null, moneyTransferFee?: number | null, income?: number | null, expense?: number | null }> | null, summary: { __typename?: 'DailyReportSummary', numberOfTransactions?: any | null, principalReceived?: number | null, pawnPrincipalAmount?: number | null, pawnInterestAmount?: number | null, buySellPrincipalAmount?: number | null, buySellInterestAmount?: number | null, moneyTransferCashInAmount?: number | null, moneyTransferCashOutAmount?: number | null, moneyTransferFee?: number | null, income?: number | null, expense?: number | null, beginningBalance?: number | null, totalAmountInTransactions?: number | null, totalInterestAmount?: number | null, endingBalance?: number | null, overrideEndingBalance?: number | null, totalPawnPrincipleAmount?: number | null, totalBuySellPrincipleAmount?: number | null } } };

export type UpdateEndingBalanceReportMutationVariables = Exact<{
  dateKey: Scalars['PositiveInt'];
  endingBalance: Scalars['Float'];
}>;


export type UpdateEndingBalanceReportMutation = { __typename?: 'Mutation', updateEndingBalanceReport: { __typename?: 'UpdateEndingBalanceReportResponse', code: number } };

export type GetInvestedPrincipalReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvestedPrincipalReportQuery = { __typename?: 'Query', getInvestedPrincipalReport: Array<{ __typename?: 'GetInvestedPrincipalReportResponse', amount: number, investor?: { __typename?: 'BasicUser', name: string } | null } | null> };

export type ExportMonthlyReportQueryVariables = Exact<{
  monthKey: Scalars['PositiveInt'];
}>;


export type ExportMonthlyReportQuery = { __typename?: 'Query', exportMonthlyReport: { __typename?: 'ExportReportResponse', code: number, downloadableUrl: any } };

export type GetMonthlyReportQueryVariables = Exact<{
  monthKey: Scalars['PositiveInt'];
}>;


export type GetMonthlyReportQuery = { __typename?: 'Query', getMonthlyReport: { __typename?: 'GetMonthlyReportResponse', days?: Array<{ __typename?: 'MonthlyReportDay', dateKey: any, principalReceived?: number | null, pawnPrincipalAdvanceAmount?: number | null, pawnPrincipalRecoupeAmount?: number | null, pawnInterestAmount?: number | null, buySellPrincipalAdvanceAmount?: number | null, buySellPrincipalRecoupeAmount?: number | null, buySellInterestAmount?: number | null, moneyTransferAmount?: number | null, moneyTransferFee?: number | null, totalIncome?: number | null, totalExpense?: number | null, numberOfDaysToCalculatePrincipalInterest?: any | null, endingBalance?: number | null, overrideEndingBalance?: number | null, endingBalanceDifference?: number | null, totalBuySellPrincipleAmount?: number | null, totalPawnPrincipleAmount?: number | null }> | null, summary?: { __typename?: 'MonthlyReportSummary', numberOfDays: any, principalReceived?: number | null, pawnPrincipalAdvanceAmount?: number | null, pawnPrincipalRecoupeAmount?: number | null, pawnInterestAmount?: number | null, buySellPrincipalAdvanceAmount?: number | null, buySellPrincipalRecoupeAmount?: number | null, buySellInterestAmount?: number | null, moneyTransferAmount?: number | null, moneyTransferFee?: number | null, totalIncome?: number | null, totalExpense?: number | null, totalInterestAmount?: number | null } | null } };


export const GetAllCompanyProductCategoriesDocument = gql`
    query getAllCompanyProductCategories {
  getAllCompanyProductCategories {
    id
    name
  }
}
    `;

/**
 * __useGetAllCompanyProductCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAllCompanyProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCompanyProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCompanyProductCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCompanyProductCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCompanyProductCategoriesQuery, GetAllCompanyProductCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCompanyProductCategoriesQuery, GetAllCompanyProductCategoriesQueryVariables>(GetAllCompanyProductCategoriesDocument, options);
      }
export function useGetAllCompanyProductCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCompanyProductCategoriesQuery, GetAllCompanyProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCompanyProductCategoriesQuery, GetAllCompanyProductCategoriesQueryVariables>(GetAllCompanyProductCategoriesDocument, options);
        }
export type GetAllCompanyProductCategoriesQueryHookResult = ReturnType<typeof useGetAllCompanyProductCategoriesQuery>;
export type GetAllCompanyProductCategoriesLazyQueryHookResult = ReturnType<typeof useGetAllCompanyProductCategoriesLazyQuery>;
export type GetAllCompanyProductCategoriesQueryResult = Apollo.QueryResult<GetAllCompanyProductCategoriesQuery, GetAllCompanyProductCategoriesQueryVariables>;
export const GetShopInvestorsDocument = gql`
    query getShopInvestors {
  getShopInvestors {
    id
    name
  }
}
    `;

/**
 * __useGetShopInvestorsQuery__
 *
 * To run a query within a React component, call `useGetShopInvestorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopInvestorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopInvestorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShopInvestorsQuery(baseOptions?: Apollo.QueryHookOptions<GetShopInvestorsQuery, GetShopInvestorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShopInvestorsQuery, GetShopInvestorsQueryVariables>(GetShopInvestorsDocument, options);
      }
export function useGetShopInvestorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShopInvestorsQuery, GetShopInvestorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShopInvestorsQuery, GetShopInvestorsQueryVariables>(GetShopInvestorsDocument, options);
        }
export type GetShopInvestorsQueryHookResult = ReturnType<typeof useGetShopInvestorsQuery>;
export type GetShopInvestorsLazyQueryHookResult = ReturnType<typeof useGetShopInvestorsLazyQuery>;
export type GetShopInvestorsQueryResult = Apollo.QueryResult<GetShopInvestorsQuery, GetShopInvestorsQueryVariables>;
export const GetConfigurationDocument = gql`
    query getConfiguration {
  getConfiguration {
    isDevelopment
    isAutomationAllowed
    toastAutoHideDuration
    isSystemInMaintenanceMode
    isPushNotificationEnabled
    isTourEntriesAllowed
    version
    buildNumber
    defaultPaginationRowsPerPage
  }
  getCurrentCompany {
    id
    name
    domain
  }
  getCurrentShop {
    id
    name
  }
  getCurrentUser {
    id
    uid
    roleId
    isContractCreatable
    isContractBackDateable
    isPrivateStatisticViewable
    name
    avatarUrl
    isMoneyTransferCreatable
    isIncomeExpenseCreatable
    isInvestedPrincipalCreatable
    shops {
      id
      name
      domain
    }
  }
}
    `;

/**
 * __useGetConfigurationQuery__
 *
 * To run a query within a React component, call `useGetConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<GetConfigurationQuery, GetConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfigurationQuery, GetConfigurationQueryVariables>(GetConfigurationDocument, options);
      }
export function useGetConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfigurationQuery, GetConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfigurationQuery, GetConfigurationQueryVariables>(GetConfigurationDocument, options);
        }
export type GetConfigurationQueryHookResult = ReturnType<typeof useGetConfigurationQuery>;
export type GetConfigurationLazyQueryHookResult = ReturnType<typeof useGetConfigurationLazyQuery>;
export type GetConfigurationQueryResult = Apollo.QueryResult<GetConfigurationQuery, GetConfigurationQueryVariables>;
export const CreateContractDocument = gql`
    mutation createContract($input: CreateContractInput!) {
  createContract(input: $input) {
    result {
      code
      message
      validationErrors {
        field
        reason
      }
    }
    contract {
      id
    }
  }
}
    `;
export type CreateContractMutationFn = Apollo.MutationFunction<CreateContractMutation, CreateContractMutationVariables>;

/**
 * __useCreateContractMutation__
 *
 * To run a mutation, you first call `useCreateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractMutation, { data, loading, error }] = useCreateContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractMutation, CreateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContractMutation, CreateContractMutationVariables>(CreateContractDocument, options);
      }
export type CreateContractMutationHookResult = ReturnType<typeof useCreateContractMutation>;
export type CreateContractMutationResult = Apollo.MutationResult<CreateContractMutation>;
export type CreateContractMutationOptions = Apollo.BaseMutationOptions<CreateContractMutation, CreateContractMutationVariables>;
export const GetInitialDataForContractNewDocument = gql`
    query getInitialDataForContractNew($writtenDate: BigInt!) {
  getNextContractWithinDayId(writtenDate: $writtenDate)
}
    `;

/**
 * __useGetInitialDataForContractNewQuery__
 *
 * To run a query within a React component, call `useGetInitialDataForContractNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialDataForContractNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialDataForContractNewQuery({
 *   variables: {
 *      writtenDate: // value for 'writtenDate'
 *   },
 * });
 */
export function useGetInitialDataForContractNewQuery(baseOptions: Apollo.QueryHookOptions<GetInitialDataForContractNewQuery, GetInitialDataForContractNewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialDataForContractNewQuery, GetInitialDataForContractNewQueryVariables>(GetInitialDataForContractNewDocument, options);
      }
export function useGetInitialDataForContractNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialDataForContractNewQuery, GetInitialDataForContractNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialDataForContractNewQuery, GetInitialDataForContractNewQueryVariables>(GetInitialDataForContractNewDocument, options);
        }
export type GetInitialDataForContractNewQueryHookResult = ReturnType<typeof useGetInitialDataForContractNewQuery>;
export type GetInitialDataForContractNewLazyQueryHookResult = ReturnType<typeof useGetInitialDataForContractNewLazyQuery>;
export type GetInitialDataForContractNewQueryResult = Apollo.QueryResult<GetInitialDataForContractNewQuery, GetInitialDataForContractNewQueryVariables>;
export const GetInitialDataForContractPrintDocument = gql`
    query getInitialDataForContractPrint($contractId: ID!) {
  getAllCompanyProductCategories {
    id
    name
  }
  getCurrentShopCompanyFinancialAccounts {
    id
    name
    financialAccountTypeId
  }
  getFinancialAccountTypes {
    id
    name
  }
  getCurrentShop {
    id
    name
    contractPrintSettings {
      id
      leftAreaLine1
      leftAreaLine2
      leftAreaLine3
      leftAreaLine4
      signingPlaceName
      showPrintTimestamp
    }
  }
  getContract(id: $contractId) {
    id
    writtenDate
    companyProductCategoryId
    customerName
    customerAddress
    customerPhone
    itemDescription
    principalAmount
    numberOfPawnDays
    lastExpirationDate
    frameCode
    engineCode
    plateNumber
    financialAccounts {
      id
      companyFinancialAccountId
      amount
    }
  }
}
    `;

/**
 * __useGetInitialDataForContractPrintQuery__
 *
 * To run a query within a React component, call `useGetInitialDataForContractPrintQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialDataForContractPrintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialDataForContractPrintQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetInitialDataForContractPrintQuery(baseOptions: Apollo.QueryHookOptions<GetInitialDataForContractPrintQuery, GetInitialDataForContractPrintQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialDataForContractPrintQuery, GetInitialDataForContractPrintQueryVariables>(GetInitialDataForContractPrintDocument, options);
      }
export function useGetInitialDataForContractPrintLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialDataForContractPrintQuery, GetInitialDataForContractPrintQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialDataForContractPrintQuery, GetInitialDataForContractPrintQueryVariables>(GetInitialDataForContractPrintDocument, options);
        }
export type GetInitialDataForContractPrintQueryHookResult = ReturnType<typeof useGetInitialDataForContractPrintQuery>;
export type GetInitialDataForContractPrintLazyQueryHookResult = ReturnType<typeof useGetInitialDataForContractPrintLazyQuery>;
export type GetInitialDataForContractPrintQueryResult = Apollo.QueryResult<GetInitialDataForContractPrintQuery, GetInitialDataForContractPrintQueryVariables>;
export const DeleteContractEventDocument = gql`
    mutation deleteContractEvent($contractEventId: ID!) {
  deleteContractEvent(contractEventId: $contractEventId) {
    code
    message
  }
}
    `;
export type DeleteContractEventMutationFn = Apollo.MutationFunction<DeleteContractEventMutation, DeleteContractEventMutationVariables>;

/**
 * __useDeleteContractEventMutation__
 *
 * To run a mutation, you first call `useDeleteContractEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractEventMutation, { data, loading, error }] = useDeleteContractEventMutation({
 *   variables: {
 *      contractEventId: // value for 'contractEventId'
 *   },
 * });
 */
export function useDeleteContractEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContractEventMutation, DeleteContractEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContractEventMutation, DeleteContractEventMutationVariables>(DeleteContractEventDocument, options);
      }
export type DeleteContractEventMutationHookResult = ReturnType<typeof useDeleteContractEventMutation>;
export type DeleteContractEventMutationResult = Apollo.MutationResult<DeleteContractEventMutation>;
export type DeleteContractEventMutationOptions = Apollo.BaseMutationOptions<DeleteContractEventMutation, DeleteContractEventMutationVariables>;
export const CreateContractFilesDocument = gql`
    mutation createContractFiles($contractId: ID!, $files: [TmpUpload!]) {
  createContractFiles(contractId: $contractId, files: $files) {
    code
    message
  }
}
    `;
export type CreateContractFilesMutationFn = Apollo.MutationFunction<CreateContractFilesMutation, CreateContractFilesMutationVariables>;

/**
 * __useCreateContractFilesMutation__
 *
 * To run a mutation, you first call `useCreateContractFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractFilesMutation, { data, loading, error }] = useCreateContractFilesMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useCreateContractFilesMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractFilesMutation, CreateContractFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContractFilesMutation, CreateContractFilesMutationVariables>(CreateContractFilesDocument, options);
      }
export type CreateContractFilesMutationHookResult = ReturnType<typeof useCreateContractFilesMutation>;
export type CreateContractFilesMutationResult = Apollo.MutationResult<CreateContractFilesMutation>;
export type CreateContractFilesMutationOptions = Apollo.BaseMutationOptions<CreateContractFilesMutation, CreateContractFilesMutationVariables>;
export const DeleteContractFileDocument = gql`
    mutation deleteContractFile($contractFileId: ID!) {
  deleteContractFile(contractFileId: $contractFileId) {
    code
    message
  }
}
    `;
export type DeleteContractFileMutationFn = Apollo.MutationFunction<DeleteContractFileMutation, DeleteContractFileMutationVariables>;

/**
 * __useDeleteContractFileMutation__
 *
 * To run a mutation, you first call `useDeleteContractFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractFileMutation, { data, loading, error }] = useDeleteContractFileMutation({
 *   variables: {
 *      contractFileId: // value for 'contractFileId'
 *   },
 * });
 */
export function useDeleteContractFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContractFileMutation, DeleteContractFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContractFileMutation, DeleteContractFileMutationVariables>(DeleteContractFileDocument, options);
      }
export type DeleteContractFileMutationHookResult = ReturnType<typeof useDeleteContractFileMutation>;
export type DeleteContractFileMutationResult = Apollo.MutationResult<DeleteContractFileMutation>;
export type DeleteContractFileMutationOptions = Apollo.BaseMutationOptions<DeleteContractFileMutation, DeleteContractFileMutationVariables>;
export const GetContractFileDownloadUrlDocument = gql`
    query getContractFileDownloadUrl($contractFileId: ID!) {
  getContractFileDownloadUrl(contractFileId: $contractFileId)
}
    `;

/**
 * __useGetContractFileDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetContractFileDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractFileDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractFileDownloadUrlQuery({
 *   variables: {
 *      contractFileId: // value for 'contractFileId'
 *   },
 * });
 */
export function useGetContractFileDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetContractFileDownloadUrlQuery, GetContractFileDownloadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractFileDownloadUrlQuery, GetContractFileDownloadUrlQueryVariables>(GetContractFileDownloadUrlDocument, options);
      }
export function useGetContractFileDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractFileDownloadUrlQuery, GetContractFileDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractFileDownloadUrlQuery, GetContractFileDownloadUrlQueryVariables>(GetContractFileDownloadUrlDocument, options);
        }
export type GetContractFileDownloadUrlQueryHookResult = ReturnType<typeof useGetContractFileDownloadUrlQuery>;
export type GetContractFileDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetContractFileDownloadUrlLazyQuery>;
export type GetContractFileDownloadUrlQueryResult = Apollo.QueryResult<GetContractFileDownloadUrlQuery, GetContractFileDownloadUrlQueryVariables>;
export const UpdateContractDocument = gql`
    mutation updateContract($contractId: ID!, $input: UpdateContractInput!) {
  updateContract(contractId: $contractId, input: $input) {
    code
    message
  }
}
    `;
export type UpdateContractMutationFn = Apollo.MutationFunction<UpdateContractMutation, UpdateContractMutationVariables>;

/**
 * __useUpdateContractMutation__
 *
 * To run a mutation, you first call `useUpdateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractMutation, { data, loading, error }] = useUpdateContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContractMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractMutation, UpdateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractMutation, UpdateContractMutationVariables>(UpdateContractDocument, options);
      }
export type UpdateContractMutationHookResult = ReturnType<typeof useUpdateContractMutation>;
export type UpdateContractMutationResult = Apollo.MutationResult<UpdateContractMutation>;
export type UpdateContractMutationOptions = Apollo.BaseMutationOptions<UpdateContractMutation, UpdateContractMutationVariables>;
export const DeleteContractDocument = gql`
    mutation deleteContract($contractId: ID!) {
  deleteContract(contractId: $contractId) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type DeleteContractMutationFn = Apollo.MutationFunction<DeleteContractMutation, DeleteContractMutationVariables>;

/**
 * __useDeleteContractMutation__
 *
 * To run a mutation, you first call `useDeleteContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractMutation, { data, loading, error }] = useDeleteContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useDeleteContractMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContractMutation, DeleteContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContractMutation, DeleteContractMutationVariables>(DeleteContractDocument, options);
      }
export type DeleteContractMutationHookResult = ReturnType<typeof useDeleteContractMutation>;
export type DeleteContractMutationResult = Apollo.MutationResult<DeleteContractMutation>;
export type DeleteContractMutationOptions = Apollo.BaseMutationOptions<DeleteContractMutation, DeleteContractMutationVariables>;
export const ExecuteContractDocument = gql`
    mutation executeContract($contractId: ID!) {
  executeContract(contractId: $contractId) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type ExecuteContractMutationFn = Apollo.MutationFunction<ExecuteContractMutation, ExecuteContractMutationVariables>;

/**
 * __useExecuteContractMutation__
 *
 * To run a mutation, you first call `useExecuteContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeContractMutation, { data, loading, error }] = useExecuteContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useExecuteContractMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteContractMutation, ExecuteContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteContractMutation, ExecuteContractMutationVariables>(ExecuteContractDocument, options);
      }
export type ExecuteContractMutationHookResult = ReturnType<typeof useExecuteContractMutation>;
export type ExecuteContractMutationResult = Apollo.MutationResult<ExecuteContractMutation>;
export type ExecuteContractMutationOptions = Apollo.BaseMutationOptions<ExecuteContractMutation, ExecuteContractMutationVariables>;
export const UpdateContractListStatusDocument = gql`
    mutation updateContractListStatus($contractId: ID!, $list: Boolean!) {
  updateContractListStatus(contractId: $contractId, list: $list) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type UpdateContractListStatusMutationFn = Apollo.MutationFunction<UpdateContractListStatusMutation, UpdateContractListStatusMutationVariables>;

/**
 * __useUpdateContractListStatusMutation__
 *
 * To run a mutation, you first call `useUpdateContractListStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractListStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractListStatusMutation, { data, loading, error }] = useUpdateContractListStatusMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      list: // value for 'list'
 *   },
 * });
 */
export function useUpdateContractListStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractListStatusMutation, UpdateContractListStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractListStatusMutation, UpdateContractListStatusMutationVariables>(UpdateContractListStatusDocument, options);
      }
export type UpdateContractListStatusMutationHookResult = ReturnType<typeof useUpdateContractListStatusMutation>;
export type UpdateContractListStatusMutationResult = Apollo.MutationResult<UpdateContractListStatusMutation>;
export type UpdateContractListStatusMutationOptions = Apollo.BaseMutationOptions<UpdateContractListStatusMutation, UpdateContractListStatusMutationVariables>;
export const ExtendContractDocument = gql`
    mutation extendContract($contractId: ID!, $input: ExtendContractInput!) {
  extendContract(contractId: $contractId, input: $input) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type ExtendContractMutationFn = Apollo.MutationFunction<ExtendContractMutation, ExtendContractMutationVariables>;

/**
 * __useExtendContractMutation__
 *
 * To run a mutation, you first call `useExtendContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendContractMutation, { data, loading, error }] = useExtendContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExtendContractMutation(baseOptions?: Apollo.MutationHookOptions<ExtendContractMutation, ExtendContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExtendContractMutation, ExtendContractMutationVariables>(ExtendContractDocument, options);
      }
export type ExtendContractMutationHookResult = ReturnType<typeof useExtendContractMutation>;
export type ExtendContractMutationResult = Apollo.MutationResult<ExtendContractMutation>;
export type ExtendContractMutationOptions = Apollo.BaseMutationOptions<ExtendContractMutation, ExtendContractMutationVariables>;
export const UpdateExtendContractDocument = gql`
    mutation updateExtendContract($eventId: ID!, $input: ExtendContractInput!) {
  updateExtendContract(eventId: $eventId, input: $input) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type UpdateExtendContractMutationFn = Apollo.MutationFunction<UpdateExtendContractMutation, UpdateExtendContractMutationVariables>;

/**
 * __useUpdateExtendContractMutation__
 *
 * To run a mutation, you first call `useUpdateExtendContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExtendContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExtendContractMutation, { data, loading, error }] = useUpdateExtendContractMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExtendContractMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExtendContractMutation, UpdateExtendContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExtendContractMutation, UpdateExtendContractMutationVariables>(UpdateExtendContractDocument, options);
      }
export type UpdateExtendContractMutationHookResult = ReturnType<typeof useUpdateExtendContractMutation>;
export type UpdateExtendContractMutationResult = Apollo.MutationResult<UpdateExtendContractMutation>;
export type UpdateExtendContractMutationOptions = Apollo.BaseMutationOptions<UpdateExtendContractMutation, UpdateExtendContractMutationVariables>;
export const PartialPaymentDocument = gql`
    mutation partialPayment($contractId: ID!, $input: PartialPaymentInput!) {
  partialPayment(contractId: $contractId, input: $input) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type PartialPaymentMutationFn = Apollo.MutationFunction<PartialPaymentMutation, PartialPaymentMutationVariables>;

/**
 * __usePartialPaymentMutation__
 *
 * To run a mutation, you first call `usePartialPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartialPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partialPaymentMutation, { data, loading, error }] = usePartialPaymentMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartialPaymentMutation(baseOptions?: Apollo.MutationHookOptions<PartialPaymentMutation, PartialPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartialPaymentMutation, PartialPaymentMutationVariables>(PartialPaymentDocument, options);
      }
export type PartialPaymentMutationHookResult = ReturnType<typeof usePartialPaymentMutation>;
export type PartialPaymentMutationResult = Apollo.MutationResult<PartialPaymentMutation>;
export type PartialPaymentMutationOptions = Apollo.BaseMutationOptions<PartialPaymentMutation, PartialPaymentMutationVariables>;
export const UpdatePartialPaymentDocument = gql`
    mutation updatePartialPayment($eventId: ID!, $input: PartialPaymentInput!) {
  updatePartialPayment(eventId: $eventId, input: $input) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type UpdatePartialPaymentMutationFn = Apollo.MutationFunction<UpdatePartialPaymentMutation, UpdatePartialPaymentMutationVariables>;

/**
 * __useUpdatePartialPaymentMutation__
 *
 * To run a mutation, you first call `useUpdatePartialPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartialPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartialPaymentMutation, { data, loading, error }] = useUpdatePartialPaymentMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePartialPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartialPaymentMutation, UpdatePartialPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartialPaymentMutation, UpdatePartialPaymentMutationVariables>(UpdatePartialPaymentDocument, options);
      }
export type UpdatePartialPaymentMutationHookResult = ReturnType<typeof useUpdatePartialPaymentMutation>;
export type UpdatePartialPaymentMutationResult = Apollo.MutationResult<UpdatePartialPaymentMutation>;
export type UpdatePartialPaymentMutationOptions = Apollo.BaseMutationOptions<UpdatePartialPaymentMutation, UpdatePartialPaymentMutationVariables>;
export const ReclaimContractDocument = gql`
    mutation reclaimContract($contractId: ID!, $input: ReclaimContractInput!) {
  reclaimContract(contractId: $contractId, input: $input) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type ReclaimContractMutationFn = Apollo.MutationFunction<ReclaimContractMutation, ReclaimContractMutationVariables>;

/**
 * __useReclaimContractMutation__
 *
 * To run a mutation, you first call `useReclaimContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReclaimContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reclaimContractMutation, { data, loading, error }] = useReclaimContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReclaimContractMutation(baseOptions?: Apollo.MutationHookOptions<ReclaimContractMutation, ReclaimContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReclaimContractMutation, ReclaimContractMutationVariables>(ReclaimContractDocument, options);
      }
export type ReclaimContractMutationHookResult = ReturnType<typeof useReclaimContractMutation>;
export type ReclaimContractMutationResult = Apollo.MutationResult<ReclaimContractMutation>;
export type ReclaimContractMutationOptions = Apollo.BaseMutationOptions<ReclaimContractMutation, ReclaimContractMutationVariables>;
export const UpdateReclaimContractDocument = gql`
    mutation updateReclaimContract($eventId: ID!, $input: ReclaimContractInput!) {
  updateReclaimContract(eventId: $eventId, input: $input) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type UpdateReclaimContractMutationFn = Apollo.MutationFunction<UpdateReclaimContractMutation, UpdateReclaimContractMutationVariables>;

/**
 * __useUpdateReclaimContractMutation__
 *
 * To run a mutation, you first call `useUpdateReclaimContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReclaimContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReclaimContractMutation, { data, loading, error }] = useUpdateReclaimContractMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReclaimContractMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReclaimContractMutation, UpdateReclaimContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReclaimContractMutation, UpdateReclaimContractMutationVariables>(UpdateReclaimContractDocument, options);
      }
export type UpdateReclaimContractMutationHookResult = ReturnType<typeof useUpdateReclaimContractMutation>;
export type UpdateReclaimContractMutationResult = Apollo.MutationResult<UpdateReclaimContractMutation>;
export type UpdateReclaimContractMutationOptions = Apollo.BaseMutationOptions<UpdateReclaimContractMutation, UpdateReclaimContractMutationVariables>;
export const AddRepairAmountDocument = gql`
    mutation addRepairAmount($contractId: ID!, $input: RepairProductInput!) {
  addRepairAmount(contractId: $contractId, input: $input) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type AddRepairAmountMutationFn = Apollo.MutationFunction<AddRepairAmountMutation, AddRepairAmountMutationVariables>;

/**
 * __useAddRepairAmountMutation__
 *
 * To run a mutation, you first call `useAddRepairAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRepairAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRepairAmountMutation, { data, loading, error }] = useAddRepairAmountMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRepairAmountMutation(baseOptions?: Apollo.MutationHookOptions<AddRepairAmountMutation, AddRepairAmountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRepairAmountMutation, AddRepairAmountMutationVariables>(AddRepairAmountDocument, options);
      }
export type AddRepairAmountMutationHookResult = ReturnType<typeof useAddRepairAmountMutation>;
export type AddRepairAmountMutationResult = Apollo.MutationResult<AddRepairAmountMutation>;
export type AddRepairAmountMutationOptions = Apollo.BaseMutationOptions<AddRepairAmountMutation, AddRepairAmountMutationVariables>;
export const UpdateAddRepairAmountDocument = gql`
    mutation updateAddRepairAmount($eventId: ID!, $input: RepairProductInput!) {
  updateAddRepairAmount(eventId: $eventId, input: $input) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type UpdateAddRepairAmountMutationFn = Apollo.MutationFunction<UpdateAddRepairAmountMutation, UpdateAddRepairAmountMutationVariables>;

/**
 * __useUpdateAddRepairAmountMutation__
 *
 * To run a mutation, you first call `useUpdateAddRepairAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddRepairAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddRepairAmountMutation, { data, loading, error }] = useUpdateAddRepairAmountMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAddRepairAmountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddRepairAmountMutation, UpdateAddRepairAmountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddRepairAmountMutation, UpdateAddRepairAmountMutationVariables>(UpdateAddRepairAmountDocument, options);
      }
export type UpdateAddRepairAmountMutationHookResult = ReturnType<typeof useUpdateAddRepairAmountMutation>;
export type UpdateAddRepairAmountMutationResult = Apollo.MutationResult<UpdateAddRepairAmountMutation>;
export type UpdateAddRepairAmountMutationOptions = Apollo.BaseMutationOptions<UpdateAddRepairAmountMutation, UpdateAddRepairAmountMutationVariables>;
export const SellContractDocument = gql`
    mutation sellContract($contractId: ID!, $input: SellContractInput!) {
  sellContract(contractId: $contractId, input: $input) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type SellContractMutationFn = Apollo.MutationFunction<SellContractMutation, SellContractMutationVariables>;

/**
 * __useSellContractMutation__
 *
 * To run a mutation, you first call `useSellContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSellContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sellContractMutation, { data, loading, error }] = useSellContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSellContractMutation(baseOptions?: Apollo.MutationHookOptions<SellContractMutation, SellContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SellContractMutation, SellContractMutationVariables>(SellContractDocument, options);
      }
export type SellContractMutationHookResult = ReturnType<typeof useSellContractMutation>;
export type SellContractMutationResult = Apollo.MutationResult<SellContractMutation>;
export type SellContractMutationOptions = Apollo.BaseMutationOptions<SellContractMutation, SellContractMutationVariables>;
export const UpdateSellContractDocument = gql`
    mutation updateSellContract($eventId: ID!, $input: SellContractInput!) {
  updateSellContract(eventId: $eventId, input: $input) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type UpdateSellContractMutationFn = Apollo.MutationFunction<UpdateSellContractMutation, UpdateSellContractMutationVariables>;

/**
 * __useUpdateSellContractMutation__
 *
 * To run a mutation, you first call `useUpdateSellContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSellContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSellContractMutation, { data, loading, error }] = useUpdateSellContractMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSellContractMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSellContractMutation, UpdateSellContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSellContractMutation, UpdateSellContractMutationVariables>(UpdateSellContractDocument, options);
      }
export type UpdateSellContractMutationHookResult = ReturnType<typeof useUpdateSellContractMutation>;
export type UpdateSellContractMutationResult = Apollo.MutationResult<UpdateSellContractMutation>;
export type UpdateSellContractMutationOptions = Apollo.BaseMutationOptions<UpdateSellContractMutation, UpdateSellContractMutationVariables>;
export const TakeMorePrincipalDocument = gql`
    mutation takeMorePrincipal($contractId: ID!, $input: TakeMorePrincipalInput!) {
  takeMorePrincipal(contractId: $contractId, input: $input) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type TakeMorePrincipalMutationFn = Apollo.MutationFunction<TakeMorePrincipalMutation, TakeMorePrincipalMutationVariables>;

/**
 * __useTakeMorePrincipalMutation__
 *
 * To run a mutation, you first call `useTakeMorePrincipalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTakeMorePrincipalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [takeMorePrincipalMutation, { data, loading, error }] = useTakeMorePrincipalMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTakeMorePrincipalMutation(baseOptions?: Apollo.MutationHookOptions<TakeMorePrincipalMutation, TakeMorePrincipalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TakeMorePrincipalMutation, TakeMorePrincipalMutationVariables>(TakeMorePrincipalDocument, options);
      }
export type TakeMorePrincipalMutationHookResult = ReturnType<typeof useTakeMorePrincipalMutation>;
export type TakeMorePrincipalMutationResult = Apollo.MutationResult<TakeMorePrincipalMutation>;
export type TakeMorePrincipalMutationOptions = Apollo.BaseMutationOptions<TakeMorePrincipalMutation, TakeMorePrincipalMutationVariables>;
export const UpdateTakeMorePrincipalDocument = gql`
    mutation updateTakeMorePrincipal($eventId: ID!, $input: TakeMorePrincipalInput!) {
  updateTakeMorePrincipal(eventId: $eventId, input: $input) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type UpdateTakeMorePrincipalMutationFn = Apollo.MutationFunction<UpdateTakeMorePrincipalMutation, UpdateTakeMorePrincipalMutationVariables>;

/**
 * __useUpdateTakeMorePrincipalMutation__
 *
 * To run a mutation, you first call `useUpdateTakeMorePrincipalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTakeMorePrincipalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTakeMorePrincipalMutation, { data, loading, error }] = useUpdateTakeMorePrincipalMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTakeMorePrincipalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTakeMorePrincipalMutation, UpdateTakeMorePrincipalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTakeMorePrincipalMutation, UpdateTakeMorePrincipalMutationVariables>(UpdateTakeMorePrincipalDocument, options);
      }
export type UpdateTakeMorePrincipalMutationHookResult = ReturnType<typeof useUpdateTakeMorePrincipalMutation>;
export type UpdateTakeMorePrincipalMutationResult = Apollo.MutationResult<UpdateTakeMorePrincipalMutation>;
export type UpdateTakeMorePrincipalMutationOptions = Apollo.BaseMutationOptions<UpdateTakeMorePrincipalMutation, UpdateTakeMorePrincipalMutationVariables>;
export const GetContractDocument = gql`
    query getContract($contractId: ID!) {
  getContract(id: $contractId) {
    id
    writtenDate
    isExpired
    numberOfDaysToLastExpirationDate
    companyProductCategoryId
    customerName
    customerPhone
    customerAddress
    itemDescription
    notes
    principalAmount
    repairAmount
    numberOfPawnDays
    expirationDate
    lastExpirationDate
    lastPrincipalAmount
    lastInterestStartingFromDate
    balanceAmount
    status
    frameCode
    engineCode
    plateNumber
    withinDayId
    netAmount
    updatedAt
    updatedBy {
      id
      name
    }
    isDraftUpdatable
    isEffectiveUpdatable
    isExecutable
    isExtendable
    isDeletable
    isReclaimable
    isListable
    isSellable
    isMorePrincipalRequestable
    isPartialPaymentable
    isRepairAddable
    financialAccounts {
      id
      companyFinancialAccountId
      amount
    }
    events {
      id
      type
      createdAt
      createdBy {
        id
        name
      }
      interestAmount
      soldAmount
      partyName
      notes
      numberOfDays
      expirationDate
      principalAmount
      repairAmount
      additionalPrincipalAmount
      customerOwedInterestAmount
      previousPrincipalAmount
      balanceAmount
      previousBalanceAmount
      amount
      financialAccounts {
        id
        companyFinancialAccountId
        amount
      }
    }
    isFileCreatable
    files {
      id
      name
      description
      category
      mimeType
      size
      createdAt
      isUpdatable
      isDeletable
    }
    isPawnTransaction
    isPrintable
  }
}
    `;

/**
 * __useGetContractQuery__
 *
 * To run a query within a React component, call `useGetContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetContractQuery(baseOptions: Apollo.QueryHookOptions<GetContractQuery, GetContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractQuery, GetContractQueryVariables>(GetContractDocument, options);
      }
export function useGetContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractQuery, GetContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractQuery, GetContractQueryVariables>(GetContractDocument, options);
        }
export type GetContractQueryHookResult = ReturnType<typeof useGetContractQuery>;
export type GetContractLazyQueryHookResult = ReturnType<typeof useGetContractLazyQuery>;
export type GetContractQueryResult = Apollo.QueryResult<GetContractQuery, GetContractQueryVariables>;
export const GetInitialDataForContractViewDocument = gql`
    query getInitialDataForContractView {
  getAllCompanyProductCategories {
    id
    name
    defaultRequiredExtensionInDays
    isDefault
  }
  getCurrentShopCompanyFinancialAccounts {
    id
    name
    isDefault
    financialAccountTypeId
  }
  getFinancialAccountTypes {
    id
    name
  }
}
    `;

/**
 * __useGetInitialDataForContractViewQuery__
 *
 * To run a query within a React component, call `useGetInitialDataForContractViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialDataForContractViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialDataForContractViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInitialDataForContractViewQuery(baseOptions?: Apollo.QueryHookOptions<GetInitialDataForContractViewQuery, GetInitialDataForContractViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialDataForContractViewQuery, GetInitialDataForContractViewQueryVariables>(GetInitialDataForContractViewDocument, options);
      }
export function useGetInitialDataForContractViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialDataForContractViewQuery, GetInitialDataForContractViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialDataForContractViewQuery, GetInitialDataForContractViewQueryVariables>(GetInitialDataForContractViewDocument, options);
        }
export type GetInitialDataForContractViewQueryHookResult = ReturnType<typeof useGetInitialDataForContractViewQuery>;
export type GetInitialDataForContractViewLazyQueryHookResult = ReturnType<typeof useGetInitialDataForContractViewLazyQuery>;
export type GetInitialDataForContractViewQueryResult = Apollo.QueryResult<GetInitialDataForContractViewQuery, GetInitialDataForContractViewQueryVariables>;
export const GetPeriodReportDocument = gql`
    query getPeriodReport($dateKey: PositiveInt!) {
  getCurrentShopCompanyFinancialAccounts {
    id
    name
    financialAccountTypeId
    isDefault
  }
  getFinancialAccountTypes {
    id
    name
  }
  getPeriodReport(dateKey: $dateKey) {
    result {
      code
      message
    }
    periodReport {
      pawnPrincipalAdvanceAmount
      pawnPrincipalRecoupeAmount
      pawnInterestAmount
      buySellPrincipalAdvanceAmount
      buySellPrincipalRecoupeAmount
      buySellInterestAmount
      moneyTransferAmount
      moneyTransferFee
      incomeExpenseExpense
      incomeExpenseIncome
      investedPrincipalReceivedAmount
      investedPrincipalRepaidAmount
      byFinancialAccounts {
        id
        companyFinancialAccountId
        beginingBalance
        endingBalance
        income
        expense
        services {
          id
          income
          expense
        }
      }
    }
  }
}
    `;

/**
 * __useGetPeriodReportQuery__
 *
 * To run a query within a React component, call `useGetPeriodReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPeriodReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPeriodReportQuery({
 *   variables: {
 *      dateKey: // value for 'dateKey'
 *   },
 * });
 */
export function useGetPeriodReportQuery(baseOptions: Apollo.QueryHookOptions<GetPeriodReportQuery, GetPeriodReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPeriodReportQuery, GetPeriodReportQueryVariables>(GetPeriodReportDocument, options);
      }
export function useGetPeriodReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPeriodReportQuery, GetPeriodReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPeriodReportQuery, GetPeriodReportQueryVariables>(GetPeriodReportDocument, options);
        }
export type GetPeriodReportQueryHookResult = ReturnType<typeof useGetPeriodReportQuery>;
export type GetPeriodReportLazyQueryHookResult = ReturnType<typeof useGetPeriodReportLazyQuery>;
export type GetPeriodReportQueryResult = Apollo.QueryResult<GetPeriodReportQuery, GetPeriodReportQueryVariables>;
export const GetIncomeExpenseForEditDocument = gql`
    query getIncomeExpenseForEdit($incomeExpenseId: ID!) {
  getIncomeExpense(id: $incomeExpenseId) {
    id
    transactionDate
    amount
    notes
    createdAt
    createdBy {
      id
      name
    }
    updatedAt
    updatedBy {
      id
      name
    }
    companyFinancialAccountId
    isUpdatable
    isDeletable
  }
  getCurrentShopCompanyFinancialAccounts {
    id
    name
    financialAccountTypeId
    isDefault
  }
  getFinancialAccountTypes {
    id
    name
  }
}
    `;

/**
 * __useGetIncomeExpenseForEditQuery__
 *
 * To run a query within a React component, call `useGetIncomeExpenseForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncomeExpenseForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncomeExpenseForEditQuery({
 *   variables: {
 *      incomeExpenseId: // value for 'incomeExpenseId'
 *   },
 * });
 */
export function useGetIncomeExpenseForEditQuery(baseOptions: Apollo.QueryHookOptions<GetIncomeExpenseForEditQuery, GetIncomeExpenseForEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncomeExpenseForEditQuery, GetIncomeExpenseForEditQueryVariables>(GetIncomeExpenseForEditDocument, options);
      }
export function useGetIncomeExpenseForEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncomeExpenseForEditQuery, GetIncomeExpenseForEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncomeExpenseForEditQuery, GetIncomeExpenseForEditQueryVariables>(GetIncomeExpenseForEditDocument, options);
        }
export type GetIncomeExpenseForEditQueryHookResult = ReturnType<typeof useGetIncomeExpenseForEditQuery>;
export type GetIncomeExpenseForEditLazyQueryHookResult = ReturnType<typeof useGetIncomeExpenseForEditLazyQuery>;
export type GetIncomeExpenseForEditQueryResult = Apollo.QueryResult<GetIncomeExpenseForEditQuery, GetIncomeExpenseForEditQueryVariables>;
export const UpdateIncomeExpenseDocument = gql`
    mutation updateIncomeExpense($incomeExpenseId: ID!, $input: IncomeExpenseInput!) {
  updateIncomeExpense(incomeExpenseId: $incomeExpenseId, input: $input) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type UpdateIncomeExpenseMutationFn = Apollo.MutationFunction<UpdateIncomeExpenseMutation, UpdateIncomeExpenseMutationVariables>;

/**
 * __useUpdateIncomeExpenseMutation__
 *
 * To run a mutation, you first call `useUpdateIncomeExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIncomeExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIncomeExpenseMutation, { data, loading, error }] = useUpdateIncomeExpenseMutation({
 *   variables: {
 *      incomeExpenseId: // value for 'incomeExpenseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIncomeExpenseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIncomeExpenseMutation, UpdateIncomeExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIncomeExpenseMutation, UpdateIncomeExpenseMutationVariables>(UpdateIncomeExpenseDocument, options);
      }
export type UpdateIncomeExpenseMutationHookResult = ReturnType<typeof useUpdateIncomeExpenseMutation>;
export type UpdateIncomeExpenseMutationResult = Apollo.MutationResult<UpdateIncomeExpenseMutation>;
export type UpdateIncomeExpenseMutationOptions = Apollo.BaseMutationOptions<UpdateIncomeExpenseMutation, UpdateIncomeExpenseMutationVariables>;
export const DeleteIncomeExpensesDocument = gql`
    mutation deleteIncomeExpenses($incomeExpenseIds: [ID]!) {
  deleteIncomeExpenses(incomeExpenseIds: $incomeExpenseIds) {
    code
    message
  }
}
    `;
export type DeleteIncomeExpensesMutationFn = Apollo.MutationFunction<DeleteIncomeExpensesMutation, DeleteIncomeExpensesMutationVariables>;

/**
 * __useDeleteIncomeExpensesMutation__
 *
 * To run a mutation, you first call `useDeleteIncomeExpensesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIncomeExpensesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIncomeExpensesMutation, { data, loading, error }] = useDeleteIncomeExpensesMutation({
 *   variables: {
 *      incomeExpenseIds: // value for 'incomeExpenseIds'
 *   },
 * });
 */
export function useDeleteIncomeExpensesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIncomeExpensesMutation, DeleteIncomeExpensesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIncomeExpensesMutation, DeleteIncomeExpensesMutationVariables>(DeleteIncomeExpensesDocument, options);
      }
export type DeleteIncomeExpensesMutationHookResult = ReturnType<typeof useDeleteIncomeExpensesMutation>;
export type DeleteIncomeExpensesMutationResult = Apollo.MutationResult<DeleteIncomeExpensesMutation>;
export type DeleteIncomeExpensesMutationOptions = Apollo.BaseMutationOptions<DeleteIncomeExpensesMutation, DeleteIncomeExpensesMutationVariables>;
export const GetInitialDataForIncomeExpenseListDocument = gql`
    query getInitialDataForIncomeExpenseList {
  getCurrentShopCompanyFinancialAccounts {
    id
    name
    financialAccountTypeId
    isDefault
  }
  getFinancialAccountTypes {
    id
    name
  }
}
    `;

/**
 * __useGetInitialDataForIncomeExpenseListQuery__
 *
 * To run a query within a React component, call `useGetInitialDataForIncomeExpenseListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialDataForIncomeExpenseListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialDataForIncomeExpenseListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInitialDataForIncomeExpenseListQuery(baseOptions?: Apollo.QueryHookOptions<GetInitialDataForIncomeExpenseListQuery, GetInitialDataForIncomeExpenseListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialDataForIncomeExpenseListQuery, GetInitialDataForIncomeExpenseListQueryVariables>(GetInitialDataForIncomeExpenseListDocument, options);
      }
export function useGetInitialDataForIncomeExpenseListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialDataForIncomeExpenseListQuery, GetInitialDataForIncomeExpenseListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialDataForIncomeExpenseListQuery, GetInitialDataForIncomeExpenseListQueryVariables>(GetInitialDataForIncomeExpenseListDocument, options);
        }
export type GetInitialDataForIncomeExpenseListQueryHookResult = ReturnType<typeof useGetInitialDataForIncomeExpenseListQuery>;
export type GetInitialDataForIncomeExpenseListLazyQueryHookResult = ReturnType<typeof useGetInitialDataForIncomeExpenseListLazyQuery>;
export type GetInitialDataForIncomeExpenseListQueryResult = Apollo.QueryResult<GetInitialDataForIncomeExpenseListQuery, GetInitialDataForIncomeExpenseListQueryVariables>;
export const GetPaginatedIncomeExpensesDocument = gql`
    query getPaginatedIncomeExpenses($page: UnsignedInt, $rowsPerPage: UnsignedInt, $order: String, $orderBy: String, $filters: IncomeExpenseFilterInput) {
  getPaginatedIncomeExpenses(
    page: $page
    rowsPerPage: $rowsPerPage
    order: $order
    orderBy: $orderBy
    filters: $filters
  ) {
    pageInfo {
      total
      matches
    }
    incomeExpenses {
      id
      createdAt
      createdBy {
        id
        name
      }
      transactionDate
      companyFinancialAccountId
      amount
      notes
      isDeletable
    }
    summary {
      totalAmount
    }
  }
}
    `;

/**
 * __useGetPaginatedIncomeExpensesQuery__
 *
 * To run a query within a React component, call `useGetPaginatedIncomeExpensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedIncomeExpensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedIncomeExpensesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      rowsPerPage: // value for 'rowsPerPage'
 *      order: // value for 'order'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPaginatedIncomeExpensesQuery(baseOptions?: Apollo.QueryHookOptions<GetPaginatedIncomeExpensesQuery, GetPaginatedIncomeExpensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedIncomeExpensesQuery, GetPaginatedIncomeExpensesQueryVariables>(GetPaginatedIncomeExpensesDocument, options);
      }
export function useGetPaginatedIncomeExpensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedIncomeExpensesQuery, GetPaginatedIncomeExpensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedIncomeExpensesQuery, GetPaginatedIncomeExpensesQueryVariables>(GetPaginatedIncomeExpensesDocument, options);
        }
export type GetPaginatedIncomeExpensesQueryHookResult = ReturnType<typeof useGetPaginatedIncomeExpensesQuery>;
export type GetPaginatedIncomeExpensesLazyQueryHookResult = ReturnType<typeof useGetPaginatedIncomeExpensesLazyQuery>;
export type GetPaginatedIncomeExpensesQueryResult = Apollo.QueryResult<GetPaginatedIncomeExpensesQuery, GetPaginatedIncomeExpensesQueryVariables>;
export const CreateIncomeExpenseDocument = gql`
    mutation createIncomeExpense($input: IncomeExpenseInput!) {
  createIncomeExpense(input: $input) {
    result {
      code
      message
      validationErrors {
        field
        code
        reason
      }
    }
    incomeExpense {
      id
    }
  }
}
    `;
export type CreateIncomeExpenseMutationFn = Apollo.MutationFunction<CreateIncomeExpenseMutation, CreateIncomeExpenseMutationVariables>;

/**
 * __useCreateIncomeExpenseMutation__
 *
 * To run a mutation, you first call `useCreateIncomeExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIncomeExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIncomeExpenseMutation, { data, loading, error }] = useCreateIncomeExpenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIncomeExpenseMutation(baseOptions?: Apollo.MutationHookOptions<CreateIncomeExpenseMutation, CreateIncomeExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIncomeExpenseMutation, CreateIncomeExpenseMutationVariables>(CreateIncomeExpenseDocument, options);
      }
export type CreateIncomeExpenseMutationHookResult = ReturnType<typeof useCreateIncomeExpenseMutation>;
export type CreateIncomeExpenseMutationResult = Apollo.MutationResult<CreateIncomeExpenseMutation>;
export type CreateIncomeExpenseMutationOptions = Apollo.BaseMutationOptions<CreateIncomeExpenseMutation, CreateIncomeExpenseMutationVariables>;
export const GetInitialDataForIncomeExpenseNewDocument = gql`
    query getInitialDataForIncomeExpenseNew {
  getCurrentShopCompanyFinancialAccounts {
    id
    name
    financialAccountTypeId
    isDefault
  }
  getFinancialAccountTypes {
    id
    name
  }
}
    `;

/**
 * __useGetInitialDataForIncomeExpenseNewQuery__
 *
 * To run a query within a React component, call `useGetInitialDataForIncomeExpenseNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialDataForIncomeExpenseNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialDataForIncomeExpenseNewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInitialDataForIncomeExpenseNewQuery(baseOptions?: Apollo.QueryHookOptions<GetInitialDataForIncomeExpenseNewQuery, GetInitialDataForIncomeExpenseNewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialDataForIncomeExpenseNewQuery, GetInitialDataForIncomeExpenseNewQueryVariables>(GetInitialDataForIncomeExpenseNewDocument, options);
      }
export function useGetInitialDataForIncomeExpenseNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialDataForIncomeExpenseNewQuery, GetInitialDataForIncomeExpenseNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialDataForIncomeExpenseNewQuery, GetInitialDataForIncomeExpenseNewQueryVariables>(GetInitialDataForIncomeExpenseNewDocument, options);
        }
export type GetInitialDataForIncomeExpenseNewQueryHookResult = ReturnType<typeof useGetInitialDataForIncomeExpenseNewQuery>;
export type GetInitialDataForIncomeExpenseNewLazyQueryHookResult = ReturnType<typeof useGetInitialDataForIncomeExpenseNewLazyQuery>;
export type GetInitialDataForIncomeExpenseNewQueryResult = Apollo.QueryResult<GetInitialDataForIncomeExpenseNewQuery, GetInitialDataForIncomeExpenseNewQueryVariables>;
export const DeleteIncomeExpenseDocument = gql`
    mutation deleteIncomeExpense($incomeExpenseId: ID!) {
  deleteIncomeExpense(incomeExpenseId: $incomeExpenseId) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type DeleteIncomeExpenseMutationFn = Apollo.MutationFunction<DeleteIncomeExpenseMutation, DeleteIncomeExpenseMutationVariables>;

/**
 * __useDeleteIncomeExpenseMutation__
 *
 * To run a mutation, you first call `useDeleteIncomeExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIncomeExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIncomeExpenseMutation, { data, loading, error }] = useDeleteIncomeExpenseMutation({
 *   variables: {
 *      incomeExpenseId: // value for 'incomeExpenseId'
 *   },
 * });
 */
export function useDeleteIncomeExpenseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIncomeExpenseMutation, DeleteIncomeExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIncomeExpenseMutation, DeleteIncomeExpenseMutationVariables>(DeleteIncomeExpenseDocument, options);
      }
export type DeleteIncomeExpenseMutationHookResult = ReturnType<typeof useDeleteIncomeExpenseMutation>;
export type DeleteIncomeExpenseMutationResult = Apollo.MutationResult<DeleteIncomeExpenseMutation>;
export type DeleteIncomeExpenseMutationOptions = Apollo.BaseMutationOptions<DeleteIncomeExpenseMutation, DeleteIncomeExpenseMutationVariables>;
export const GetIncomeExpenseForViewDocument = gql`
    query getIncomeExpenseForView($incomeExpenseId: ID!) {
  getIncomeExpense(id: $incomeExpenseId) {
    id
    transactionDate
    amount
    companyFinancialAccountId
    notes
    createdAt
    createdBy {
      id
      name
    }
    updatedAt
    updatedBy {
      id
      name
    }
    isUpdatable
    isDeletable
  }
  getCurrentShopCompanyFinancialAccounts {
    id
    name
    financialAccountTypeId
    isDefault
  }
  getFinancialAccountTypes {
    id
    name
  }
}
    `;

/**
 * __useGetIncomeExpenseForViewQuery__
 *
 * To run a query within a React component, call `useGetIncomeExpenseForViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncomeExpenseForViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncomeExpenseForViewQuery({
 *   variables: {
 *      incomeExpenseId: // value for 'incomeExpenseId'
 *   },
 * });
 */
export function useGetIncomeExpenseForViewQuery(baseOptions: Apollo.QueryHookOptions<GetIncomeExpenseForViewQuery, GetIncomeExpenseForViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncomeExpenseForViewQuery, GetIncomeExpenseForViewQueryVariables>(GetIncomeExpenseForViewDocument, options);
      }
export function useGetIncomeExpenseForViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncomeExpenseForViewQuery, GetIncomeExpenseForViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncomeExpenseForViewQuery, GetIncomeExpenseForViewQueryVariables>(GetIncomeExpenseForViewDocument, options);
        }
export type GetIncomeExpenseForViewQueryHookResult = ReturnType<typeof useGetIncomeExpenseForViewQuery>;
export type GetIncomeExpenseForViewLazyQueryHookResult = ReturnType<typeof useGetIncomeExpenseForViewLazyQuery>;
export type GetIncomeExpenseForViewQueryResult = Apollo.QueryResult<GetIncomeExpenseForViewQuery, GetIncomeExpenseForViewQueryVariables>;
export const GetInvestedPrincipalForEditDocument = gql`
    query getInvestedPrincipalForEdit($investedPrincipalId: ID!) {
  getInvestedPrincipal(id: $investedPrincipalId) {
    id
    transactionDate
    amount
    companyFinancialAccountId
    investor {
      id
      name
    }
    notes
    createdAt
    createdBy {
      id
      name
    }
    updatedAt
    updatedBy {
      id
      name
    }
    interestRate
    isUpdatable
    isDeletable
    investorUserId
  }
  getCurrentShopCompanyFinancialAccounts {
    id
    name
    financialAccountTypeId
    isDefault
  }
  getFinancialAccountTypes {
    id
    name
  }
  getShopInvestors {
    id
    name
    interestRate
  }
}
    `;

/**
 * __useGetInvestedPrincipalForEditQuery__
 *
 * To run a query within a React component, call `useGetInvestedPrincipalForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestedPrincipalForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestedPrincipalForEditQuery({
 *   variables: {
 *      investedPrincipalId: // value for 'investedPrincipalId'
 *   },
 * });
 */
export function useGetInvestedPrincipalForEditQuery(baseOptions: Apollo.QueryHookOptions<GetInvestedPrincipalForEditQuery, GetInvestedPrincipalForEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvestedPrincipalForEditQuery, GetInvestedPrincipalForEditQueryVariables>(GetInvestedPrincipalForEditDocument, options);
      }
export function useGetInvestedPrincipalForEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvestedPrincipalForEditQuery, GetInvestedPrincipalForEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvestedPrincipalForEditQuery, GetInvestedPrincipalForEditQueryVariables>(GetInvestedPrincipalForEditDocument, options);
        }
export type GetInvestedPrincipalForEditQueryHookResult = ReturnType<typeof useGetInvestedPrincipalForEditQuery>;
export type GetInvestedPrincipalForEditLazyQueryHookResult = ReturnType<typeof useGetInvestedPrincipalForEditLazyQuery>;
export type GetInvestedPrincipalForEditQueryResult = Apollo.QueryResult<GetInvestedPrincipalForEditQuery, GetInvestedPrincipalForEditQueryVariables>;
export const UpdateInvestedPrincipalDocument = gql`
    mutation updateInvestedPrincipal($investedPrincipalId: ID!, $input: InvestedPrincipalInput!) {
  updateInvestedPrincipal(
    investedPrincipalId: $investedPrincipalId
    input: $input
  ) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type UpdateInvestedPrincipalMutationFn = Apollo.MutationFunction<UpdateInvestedPrincipalMutation, UpdateInvestedPrincipalMutationVariables>;

/**
 * __useUpdateInvestedPrincipalMutation__
 *
 * To run a mutation, you first call `useUpdateInvestedPrincipalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvestedPrincipalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvestedPrincipalMutation, { data, loading, error }] = useUpdateInvestedPrincipalMutation({
 *   variables: {
 *      investedPrincipalId: // value for 'investedPrincipalId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInvestedPrincipalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvestedPrincipalMutation, UpdateInvestedPrincipalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvestedPrincipalMutation, UpdateInvestedPrincipalMutationVariables>(UpdateInvestedPrincipalDocument, options);
      }
export type UpdateInvestedPrincipalMutationHookResult = ReturnType<typeof useUpdateInvestedPrincipalMutation>;
export type UpdateInvestedPrincipalMutationResult = Apollo.MutationResult<UpdateInvestedPrincipalMutation>;
export type UpdateInvestedPrincipalMutationOptions = Apollo.BaseMutationOptions<UpdateInvestedPrincipalMutation, UpdateInvestedPrincipalMutationVariables>;
export const DeleteInvestedPrincipalsDocument = gql`
    mutation deleteInvestedPrincipals($investedPrincipalIds: [ID]!) {
  deleteInvestedPrincipals(investedPrincipalIds: $investedPrincipalIds) {
    code
    message
  }
}
    `;
export type DeleteInvestedPrincipalsMutationFn = Apollo.MutationFunction<DeleteInvestedPrincipalsMutation, DeleteInvestedPrincipalsMutationVariables>;

/**
 * __useDeleteInvestedPrincipalsMutation__
 *
 * To run a mutation, you first call `useDeleteInvestedPrincipalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvestedPrincipalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvestedPrincipalsMutation, { data, loading, error }] = useDeleteInvestedPrincipalsMutation({
 *   variables: {
 *      investedPrincipalIds: // value for 'investedPrincipalIds'
 *   },
 * });
 */
export function useDeleteInvestedPrincipalsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvestedPrincipalsMutation, DeleteInvestedPrincipalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInvestedPrincipalsMutation, DeleteInvestedPrincipalsMutationVariables>(DeleteInvestedPrincipalsDocument, options);
      }
export type DeleteInvestedPrincipalsMutationHookResult = ReturnType<typeof useDeleteInvestedPrincipalsMutation>;
export type DeleteInvestedPrincipalsMutationResult = Apollo.MutationResult<DeleteInvestedPrincipalsMutation>;
export type DeleteInvestedPrincipalsMutationOptions = Apollo.BaseMutationOptions<DeleteInvestedPrincipalsMutation, DeleteInvestedPrincipalsMutationVariables>;
export const GetInitialDataForInvestedPrincipalListDocument = gql`
    query getInitialDataForInvestedPrincipalList {
  getCurrentShopCompanyFinancialAccounts {
    id
    name
    financialAccountTypeId
    isDefault
  }
  getFinancialAccountTypes {
    id
    name
  }
}
    `;

/**
 * __useGetInitialDataForInvestedPrincipalListQuery__
 *
 * To run a query within a React component, call `useGetInitialDataForInvestedPrincipalListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialDataForInvestedPrincipalListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialDataForInvestedPrincipalListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInitialDataForInvestedPrincipalListQuery(baseOptions?: Apollo.QueryHookOptions<GetInitialDataForInvestedPrincipalListQuery, GetInitialDataForInvestedPrincipalListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialDataForInvestedPrincipalListQuery, GetInitialDataForInvestedPrincipalListQueryVariables>(GetInitialDataForInvestedPrincipalListDocument, options);
      }
export function useGetInitialDataForInvestedPrincipalListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialDataForInvestedPrincipalListQuery, GetInitialDataForInvestedPrincipalListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialDataForInvestedPrincipalListQuery, GetInitialDataForInvestedPrincipalListQueryVariables>(GetInitialDataForInvestedPrincipalListDocument, options);
        }
export type GetInitialDataForInvestedPrincipalListQueryHookResult = ReturnType<typeof useGetInitialDataForInvestedPrincipalListQuery>;
export type GetInitialDataForInvestedPrincipalListLazyQueryHookResult = ReturnType<typeof useGetInitialDataForInvestedPrincipalListLazyQuery>;
export type GetInitialDataForInvestedPrincipalListQueryResult = Apollo.QueryResult<GetInitialDataForInvestedPrincipalListQuery, GetInitialDataForInvestedPrincipalListQueryVariables>;
export const GetPaginatedInvestedPrincipalsDocument = gql`
    query getPaginatedInvestedPrincipals($page: UnsignedInt, $rowsPerPage: UnsignedInt, $order: String, $orderBy: String, $filters: InvestedPrincipalFilterInput) {
  getPaginatedInvestedPrincipals(
    page: $page
    rowsPerPage: $rowsPerPage
    order: $order
    orderBy: $orderBy
    filters: $filters
  ) {
    pageInfo {
      total
      matches
    }
    investedPrincipals {
      id
      createdAt
      createdBy {
        id
        name
      }
      transactionDate
      investor {
        id
        name
      }
      companyFinancialAccountId
      amount
      interestRate
      interestRate
      isDeletable
      investorUserId
    }
    summary {
      totalAmount
      averageInterestRate
    }
  }
}
    `;

/**
 * __useGetPaginatedInvestedPrincipalsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedInvestedPrincipalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedInvestedPrincipalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedInvestedPrincipalsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      rowsPerPage: // value for 'rowsPerPage'
 *      order: // value for 'order'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPaginatedInvestedPrincipalsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaginatedInvestedPrincipalsQuery, GetPaginatedInvestedPrincipalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedInvestedPrincipalsQuery, GetPaginatedInvestedPrincipalsQueryVariables>(GetPaginatedInvestedPrincipalsDocument, options);
      }
export function useGetPaginatedInvestedPrincipalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedInvestedPrincipalsQuery, GetPaginatedInvestedPrincipalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedInvestedPrincipalsQuery, GetPaginatedInvestedPrincipalsQueryVariables>(GetPaginatedInvestedPrincipalsDocument, options);
        }
export type GetPaginatedInvestedPrincipalsQueryHookResult = ReturnType<typeof useGetPaginatedInvestedPrincipalsQuery>;
export type GetPaginatedInvestedPrincipalsLazyQueryHookResult = ReturnType<typeof useGetPaginatedInvestedPrincipalsLazyQuery>;
export type GetPaginatedInvestedPrincipalsQueryResult = Apollo.QueryResult<GetPaginatedInvestedPrincipalsQuery, GetPaginatedInvestedPrincipalsQueryVariables>;
export const CreateInvestedPrincipalDocument = gql`
    mutation createInvestedPrincipal($input: InvestedPrincipalInput!) {
  createInvestedPrincipal(input: $input) {
    result {
      code
      message
      validationErrors {
        field
        code
        reason
      }
    }
    investedPrincipal {
      id
    }
  }
}
    `;
export type CreateInvestedPrincipalMutationFn = Apollo.MutationFunction<CreateInvestedPrincipalMutation, CreateInvestedPrincipalMutationVariables>;

/**
 * __useCreateInvestedPrincipalMutation__
 *
 * To run a mutation, you first call `useCreateInvestedPrincipalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvestedPrincipalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvestedPrincipalMutation, { data, loading, error }] = useCreateInvestedPrincipalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvestedPrincipalMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvestedPrincipalMutation, CreateInvestedPrincipalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvestedPrincipalMutation, CreateInvestedPrincipalMutationVariables>(CreateInvestedPrincipalDocument, options);
      }
export type CreateInvestedPrincipalMutationHookResult = ReturnType<typeof useCreateInvestedPrincipalMutation>;
export type CreateInvestedPrincipalMutationResult = Apollo.MutationResult<CreateInvestedPrincipalMutation>;
export type CreateInvestedPrincipalMutationOptions = Apollo.BaseMutationOptions<CreateInvestedPrincipalMutation, CreateInvestedPrincipalMutationVariables>;
export const GetInitialDataForInvestedPrincipalNewDocument = gql`
    query getInitialDataForInvestedPrincipalNew {
  getCurrentShopCompanyFinancialAccounts {
    id
    name
    financialAccountTypeId
    isDefault
  }
  getFinancialAccountTypes {
    id
    name
  }
  getShopInvestors {
    id
    name
    interestRate
  }
}
    `;

/**
 * __useGetInitialDataForInvestedPrincipalNewQuery__
 *
 * To run a query within a React component, call `useGetInitialDataForInvestedPrincipalNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialDataForInvestedPrincipalNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialDataForInvestedPrincipalNewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInitialDataForInvestedPrincipalNewQuery(baseOptions?: Apollo.QueryHookOptions<GetInitialDataForInvestedPrincipalNewQuery, GetInitialDataForInvestedPrincipalNewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialDataForInvestedPrincipalNewQuery, GetInitialDataForInvestedPrincipalNewQueryVariables>(GetInitialDataForInvestedPrincipalNewDocument, options);
      }
export function useGetInitialDataForInvestedPrincipalNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialDataForInvestedPrincipalNewQuery, GetInitialDataForInvestedPrincipalNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialDataForInvestedPrincipalNewQuery, GetInitialDataForInvestedPrincipalNewQueryVariables>(GetInitialDataForInvestedPrincipalNewDocument, options);
        }
export type GetInitialDataForInvestedPrincipalNewQueryHookResult = ReturnType<typeof useGetInitialDataForInvestedPrincipalNewQuery>;
export type GetInitialDataForInvestedPrincipalNewLazyQueryHookResult = ReturnType<typeof useGetInitialDataForInvestedPrincipalNewLazyQuery>;
export type GetInitialDataForInvestedPrincipalNewQueryResult = Apollo.QueryResult<GetInitialDataForInvestedPrincipalNewQuery, GetInitialDataForInvestedPrincipalNewQueryVariables>;
export const DeleteInvestedPrincipalDocument = gql`
    mutation deleteInvestedPrincipal($investedPrincipalId: ID!) {
  deleteInvestedPrincipal(investedPrincipalId: $investedPrincipalId) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type DeleteInvestedPrincipalMutationFn = Apollo.MutationFunction<DeleteInvestedPrincipalMutation, DeleteInvestedPrincipalMutationVariables>;

/**
 * __useDeleteInvestedPrincipalMutation__
 *
 * To run a mutation, you first call `useDeleteInvestedPrincipalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvestedPrincipalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvestedPrincipalMutation, { data, loading, error }] = useDeleteInvestedPrincipalMutation({
 *   variables: {
 *      investedPrincipalId: // value for 'investedPrincipalId'
 *   },
 * });
 */
export function useDeleteInvestedPrincipalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvestedPrincipalMutation, DeleteInvestedPrincipalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInvestedPrincipalMutation, DeleteInvestedPrincipalMutationVariables>(DeleteInvestedPrincipalDocument, options);
      }
export type DeleteInvestedPrincipalMutationHookResult = ReturnType<typeof useDeleteInvestedPrincipalMutation>;
export type DeleteInvestedPrincipalMutationResult = Apollo.MutationResult<DeleteInvestedPrincipalMutation>;
export type DeleteInvestedPrincipalMutationOptions = Apollo.BaseMutationOptions<DeleteInvestedPrincipalMutation, DeleteInvestedPrincipalMutationVariables>;
export const GetInvestedPrincipalForViewDocument = gql`
    query getInvestedPrincipalForView($investedPrincipalId: ID!) {
  getInvestedPrincipal(id: $investedPrincipalId) {
    id
    transactionDate
    amount
    companyFinancialAccountId
    investor {
      id
      name
    }
    notes
    interestRate
    createdAt
    createdBy {
      id
      name
    }
    updatedAt
    updatedBy {
      id
      name
    }
    isUpdatable
    isDeletable
  }
  getCurrentShopCompanyFinancialAccounts {
    id
    name
    financialAccountTypeId
    isDefault
  }
  getFinancialAccountTypes {
    id
    name
  }
}
    `;

/**
 * __useGetInvestedPrincipalForViewQuery__
 *
 * To run a query within a React component, call `useGetInvestedPrincipalForViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestedPrincipalForViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestedPrincipalForViewQuery({
 *   variables: {
 *      investedPrincipalId: // value for 'investedPrincipalId'
 *   },
 * });
 */
export function useGetInvestedPrincipalForViewQuery(baseOptions: Apollo.QueryHookOptions<GetInvestedPrincipalForViewQuery, GetInvestedPrincipalForViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvestedPrincipalForViewQuery, GetInvestedPrincipalForViewQueryVariables>(GetInvestedPrincipalForViewDocument, options);
      }
export function useGetInvestedPrincipalForViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvestedPrincipalForViewQuery, GetInvestedPrincipalForViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvestedPrincipalForViewQuery, GetInvestedPrincipalForViewQueryVariables>(GetInvestedPrincipalForViewDocument, options);
        }
export type GetInvestedPrincipalForViewQueryHookResult = ReturnType<typeof useGetInvestedPrincipalForViewQuery>;
export type GetInvestedPrincipalForViewLazyQueryHookResult = ReturnType<typeof useGetInvestedPrincipalForViewLazyQuery>;
export type GetInvestedPrincipalForViewQueryResult = Apollo.QueryResult<GetInvestedPrincipalForViewQuery, GetInvestedPrincipalForViewQueryVariables>;
export const GetMoneyTransferForEditDocument = gql`
    query getMoneyTransferForEdit($moneyTransferId: ID!) {
  getMoneyTransfer(id: $moneyTransferId) {
    id
    transferredDate
    amount
    fromCompanyFinancialAccountId
    customerName
    notes
    createdAt
    createdBy {
      id
      name
    }
    updatedAt
    updatedBy {
      id
      name
    }
    fee
    toCompanyFinancialAccountId
    isUpdatable
    isDeletable
  }
  getCurrentShopCompanyFinancialAccounts {
    id
    name
    financialAccountTypeId
    isDefault
  }
  getFinancialAccountTypes {
    id
    name
  }
}
    `;

/**
 * __useGetMoneyTransferForEditQuery__
 *
 * To run a query within a React component, call `useGetMoneyTransferForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoneyTransferForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoneyTransferForEditQuery({
 *   variables: {
 *      moneyTransferId: // value for 'moneyTransferId'
 *   },
 * });
 */
export function useGetMoneyTransferForEditQuery(baseOptions: Apollo.QueryHookOptions<GetMoneyTransferForEditQuery, GetMoneyTransferForEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMoneyTransferForEditQuery, GetMoneyTransferForEditQueryVariables>(GetMoneyTransferForEditDocument, options);
      }
export function useGetMoneyTransferForEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMoneyTransferForEditQuery, GetMoneyTransferForEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMoneyTransferForEditQuery, GetMoneyTransferForEditQueryVariables>(GetMoneyTransferForEditDocument, options);
        }
export type GetMoneyTransferForEditQueryHookResult = ReturnType<typeof useGetMoneyTransferForEditQuery>;
export type GetMoneyTransferForEditLazyQueryHookResult = ReturnType<typeof useGetMoneyTransferForEditLazyQuery>;
export type GetMoneyTransferForEditQueryResult = Apollo.QueryResult<GetMoneyTransferForEditQuery, GetMoneyTransferForEditQueryVariables>;
export const UpdateMoneyTransferDocument = gql`
    mutation updateMoneyTransfer($moneyTransferId: ID!, $input: MoneyTransferInput!) {
  updateMoneyTransfer(moneyTransferId: $moneyTransferId, input: $input) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type UpdateMoneyTransferMutationFn = Apollo.MutationFunction<UpdateMoneyTransferMutation, UpdateMoneyTransferMutationVariables>;

/**
 * __useUpdateMoneyTransferMutation__
 *
 * To run a mutation, you first call `useUpdateMoneyTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMoneyTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMoneyTransferMutation, { data, loading, error }] = useUpdateMoneyTransferMutation({
 *   variables: {
 *      moneyTransferId: // value for 'moneyTransferId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMoneyTransferMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMoneyTransferMutation, UpdateMoneyTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMoneyTransferMutation, UpdateMoneyTransferMutationVariables>(UpdateMoneyTransferDocument, options);
      }
export type UpdateMoneyTransferMutationHookResult = ReturnType<typeof useUpdateMoneyTransferMutation>;
export type UpdateMoneyTransferMutationResult = Apollo.MutationResult<UpdateMoneyTransferMutation>;
export type UpdateMoneyTransferMutationOptions = Apollo.BaseMutationOptions<UpdateMoneyTransferMutation, UpdateMoneyTransferMutationVariables>;
export const DeleteMoneyTransfersDocument = gql`
    mutation deleteMoneyTransfers($moneyTransferIds: [ID]!) {
  deleteMoneyTransfers(moneyTransferIds: $moneyTransferIds) {
    code
    message
  }
}
    `;
export type DeleteMoneyTransfersMutationFn = Apollo.MutationFunction<DeleteMoneyTransfersMutation, DeleteMoneyTransfersMutationVariables>;

/**
 * __useDeleteMoneyTransfersMutation__
 *
 * To run a mutation, you first call `useDeleteMoneyTransfersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMoneyTransfersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMoneyTransfersMutation, { data, loading, error }] = useDeleteMoneyTransfersMutation({
 *   variables: {
 *      moneyTransferIds: // value for 'moneyTransferIds'
 *   },
 * });
 */
export function useDeleteMoneyTransfersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMoneyTransfersMutation, DeleteMoneyTransfersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMoneyTransfersMutation, DeleteMoneyTransfersMutationVariables>(DeleteMoneyTransfersDocument, options);
      }
export type DeleteMoneyTransfersMutationHookResult = ReturnType<typeof useDeleteMoneyTransfersMutation>;
export type DeleteMoneyTransfersMutationResult = Apollo.MutationResult<DeleteMoneyTransfersMutation>;
export type DeleteMoneyTransfersMutationOptions = Apollo.BaseMutationOptions<DeleteMoneyTransfersMutation, DeleteMoneyTransfersMutationVariables>;
export const GetInitialDataForMoneyTransferListDocument = gql`
    query getInitialDataForMoneyTransferList {
  getCurrentShopCompanyFinancialAccounts {
    id
    name
    financialAccountTypeId
    isDefault
  }
  getFinancialAccountTypes {
    id
    name
  }
}
    `;

/**
 * __useGetInitialDataForMoneyTransferListQuery__
 *
 * To run a query within a React component, call `useGetInitialDataForMoneyTransferListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialDataForMoneyTransferListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialDataForMoneyTransferListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInitialDataForMoneyTransferListQuery(baseOptions?: Apollo.QueryHookOptions<GetInitialDataForMoneyTransferListQuery, GetInitialDataForMoneyTransferListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialDataForMoneyTransferListQuery, GetInitialDataForMoneyTransferListQueryVariables>(GetInitialDataForMoneyTransferListDocument, options);
      }
export function useGetInitialDataForMoneyTransferListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialDataForMoneyTransferListQuery, GetInitialDataForMoneyTransferListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialDataForMoneyTransferListQuery, GetInitialDataForMoneyTransferListQueryVariables>(GetInitialDataForMoneyTransferListDocument, options);
        }
export type GetInitialDataForMoneyTransferListQueryHookResult = ReturnType<typeof useGetInitialDataForMoneyTransferListQuery>;
export type GetInitialDataForMoneyTransferListLazyQueryHookResult = ReturnType<typeof useGetInitialDataForMoneyTransferListLazyQuery>;
export type GetInitialDataForMoneyTransferListQueryResult = Apollo.QueryResult<GetInitialDataForMoneyTransferListQuery, GetInitialDataForMoneyTransferListQueryVariables>;
export const GetPaginatedMoneyTransfersDocument = gql`
    query getPaginatedMoneyTransfers($page: UnsignedInt, $rowsPerPage: UnsignedInt, $order: String, $orderBy: String, $filters: MoneyTransferFilterInput) {
  getPaginatedMoneyTransfers(
    page: $page
    rowsPerPage: $rowsPerPage
    order: $order
    orderBy: $orderBy
    filters: $filters
  ) {
    pageInfo {
      total
      matches
    }
    moneyTransfers {
      id
      createdAt
      createdBy {
        id
        name
      }
      transferredDate
      customerName
      fromCompanyFinancialAccountId
      amount
      fee
      toCompanyFinancialAccountId
      isDeletable
    }
    summary {
      totalAmount
      totalFee
    }
  }
}
    `;

/**
 * __useGetPaginatedMoneyTransfersQuery__
 *
 * To run a query within a React component, call `useGetPaginatedMoneyTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedMoneyTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedMoneyTransfersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      rowsPerPage: // value for 'rowsPerPage'
 *      order: // value for 'order'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPaginatedMoneyTransfersQuery(baseOptions?: Apollo.QueryHookOptions<GetPaginatedMoneyTransfersQuery, GetPaginatedMoneyTransfersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedMoneyTransfersQuery, GetPaginatedMoneyTransfersQueryVariables>(GetPaginatedMoneyTransfersDocument, options);
      }
export function useGetPaginatedMoneyTransfersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedMoneyTransfersQuery, GetPaginatedMoneyTransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedMoneyTransfersQuery, GetPaginatedMoneyTransfersQueryVariables>(GetPaginatedMoneyTransfersDocument, options);
        }
export type GetPaginatedMoneyTransfersQueryHookResult = ReturnType<typeof useGetPaginatedMoneyTransfersQuery>;
export type GetPaginatedMoneyTransfersLazyQueryHookResult = ReturnType<typeof useGetPaginatedMoneyTransfersLazyQuery>;
export type GetPaginatedMoneyTransfersQueryResult = Apollo.QueryResult<GetPaginatedMoneyTransfersQuery, GetPaginatedMoneyTransfersQueryVariables>;
export const CreateMoneyTransferDocument = gql`
    mutation createMoneyTransfer($input: MoneyTransferInput!) {
  createMoneyTransfer(input: $input) {
    result {
      code
      message
      validationErrors {
        field
        code
        reason
      }
    }
    moneyTransfer {
      id
    }
  }
}
    `;
export type CreateMoneyTransferMutationFn = Apollo.MutationFunction<CreateMoneyTransferMutation, CreateMoneyTransferMutationVariables>;

/**
 * __useCreateMoneyTransferMutation__
 *
 * To run a mutation, you first call `useCreateMoneyTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMoneyTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMoneyTransferMutation, { data, loading, error }] = useCreateMoneyTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMoneyTransferMutation(baseOptions?: Apollo.MutationHookOptions<CreateMoneyTransferMutation, CreateMoneyTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMoneyTransferMutation, CreateMoneyTransferMutationVariables>(CreateMoneyTransferDocument, options);
      }
export type CreateMoneyTransferMutationHookResult = ReturnType<typeof useCreateMoneyTransferMutation>;
export type CreateMoneyTransferMutationResult = Apollo.MutationResult<CreateMoneyTransferMutation>;
export type CreateMoneyTransferMutationOptions = Apollo.BaseMutationOptions<CreateMoneyTransferMutation, CreateMoneyTransferMutationVariables>;
export const GetInitialDataForMoneyTransferNewDocument = gql`
    query getInitialDataForMoneyTransferNew {
  getCurrentShopCompanyFinancialAccounts {
    id
    name
    financialAccountTypeId
    isDefault
  }
  getFinancialAccountTypes {
    id
    name
  }
}
    `;

/**
 * __useGetInitialDataForMoneyTransferNewQuery__
 *
 * To run a query within a React component, call `useGetInitialDataForMoneyTransferNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialDataForMoneyTransferNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialDataForMoneyTransferNewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInitialDataForMoneyTransferNewQuery(baseOptions?: Apollo.QueryHookOptions<GetInitialDataForMoneyTransferNewQuery, GetInitialDataForMoneyTransferNewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialDataForMoneyTransferNewQuery, GetInitialDataForMoneyTransferNewQueryVariables>(GetInitialDataForMoneyTransferNewDocument, options);
      }
export function useGetInitialDataForMoneyTransferNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialDataForMoneyTransferNewQuery, GetInitialDataForMoneyTransferNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialDataForMoneyTransferNewQuery, GetInitialDataForMoneyTransferNewQueryVariables>(GetInitialDataForMoneyTransferNewDocument, options);
        }
export type GetInitialDataForMoneyTransferNewQueryHookResult = ReturnType<typeof useGetInitialDataForMoneyTransferNewQuery>;
export type GetInitialDataForMoneyTransferNewLazyQueryHookResult = ReturnType<typeof useGetInitialDataForMoneyTransferNewLazyQuery>;
export type GetInitialDataForMoneyTransferNewQueryResult = Apollo.QueryResult<GetInitialDataForMoneyTransferNewQuery, GetInitialDataForMoneyTransferNewQueryVariables>;
export const DeleteMoneyTransferDocument = gql`
    mutation deleteMoneyTransfer($moneyTransferId: ID!) {
  deleteMoneyTransfer(moneyTransferId: $moneyTransferId) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type DeleteMoneyTransferMutationFn = Apollo.MutationFunction<DeleteMoneyTransferMutation, DeleteMoneyTransferMutationVariables>;

/**
 * __useDeleteMoneyTransferMutation__
 *
 * To run a mutation, you first call `useDeleteMoneyTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMoneyTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMoneyTransferMutation, { data, loading, error }] = useDeleteMoneyTransferMutation({
 *   variables: {
 *      moneyTransferId: // value for 'moneyTransferId'
 *   },
 * });
 */
export function useDeleteMoneyTransferMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMoneyTransferMutation, DeleteMoneyTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMoneyTransferMutation, DeleteMoneyTransferMutationVariables>(DeleteMoneyTransferDocument, options);
      }
export type DeleteMoneyTransferMutationHookResult = ReturnType<typeof useDeleteMoneyTransferMutation>;
export type DeleteMoneyTransferMutationResult = Apollo.MutationResult<DeleteMoneyTransferMutation>;
export type DeleteMoneyTransferMutationOptions = Apollo.BaseMutationOptions<DeleteMoneyTransferMutation, DeleteMoneyTransferMutationVariables>;
export const GetMoneyTransferForViewDocument = gql`
    query getMoneyTransferForView($moneyTransferId: ID!) {
  getMoneyTransfer(id: $moneyTransferId) {
    id
    transferredDate
    amount
    fromCompanyFinancialAccountId
    customerName
    notes
    fee
    toCompanyFinancialAccountId
    createdAt
    createdBy {
      id
      name
    }
    updatedAt
    updatedBy {
      id
      name
    }
    isUpdatable
    isDeletable
  }
  getCurrentShopCompanyFinancialAccounts {
    id
    name
    financialAccountTypeId
    isDefault
  }
  getFinancialAccountTypes {
    id
    name
  }
}
    `;

/**
 * __useGetMoneyTransferForViewQuery__
 *
 * To run a query within a React component, call `useGetMoneyTransferForViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoneyTransferForViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoneyTransferForViewQuery({
 *   variables: {
 *      moneyTransferId: // value for 'moneyTransferId'
 *   },
 * });
 */
export function useGetMoneyTransferForViewQuery(baseOptions: Apollo.QueryHookOptions<GetMoneyTransferForViewQuery, GetMoneyTransferForViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMoneyTransferForViewQuery, GetMoneyTransferForViewQueryVariables>(GetMoneyTransferForViewDocument, options);
      }
export function useGetMoneyTransferForViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMoneyTransferForViewQuery, GetMoneyTransferForViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMoneyTransferForViewQuery, GetMoneyTransferForViewQueryVariables>(GetMoneyTransferForViewDocument, options);
        }
export type GetMoneyTransferForViewQueryHookResult = ReturnType<typeof useGetMoneyTransferForViewQuery>;
export type GetMoneyTransferForViewLazyQueryHookResult = ReturnType<typeof useGetMoneyTransferForViewLazyQuery>;
export type GetMoneyTransferForViewQueryResult = Apollo.QueryResult<GetMoneyTransferForViewQuery, GetMoneyTransferForViewQueryVariables>;
export const DeleteContractsDocument = gql`
    mutation deleteContracts($contractIds: [ID]!) {
  deleteContracts(contractIds: $contractIds) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type DeleteContractsMutationFn = Apollo.MutationFunction<DeleteContractsMutation, DeleteContractsMutationVariables>;

/**
 * __useDeleteContractsMutation__
 *
 * To run a mutation, you first call `useDeleteContractsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractsMutation, { data, loading, error }] = useDeleteContractsMutation({
 *   variables: {
 *      contractIds: // value for 'contractIds'
 *   },
 * });
 */
export function useDeleteContractsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContractsMutation, DeleteContractsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContractsMutation, DeleteContractsMutationVariables>(DeleteContractsDocument, options);
      }
export type DeleteContractsMutationHookResult = ReturnType<typeof useDeleteContractsMutation>;
export type DeleteContractsMutationResult = Apollo.MutationResult<DeleteContractsMutation>;
export type DeleteContractsMutationOptions = Apollo.BaseMutationOptions<DeleteContractsMutation, DeleteContractsMutationVariables>;
export const UpdateContractsListStatusDocument = gql`
    mutation updateContractsListStatus($contractIds: [ID]!, $list: Boolean!) {
  updateContractsListStatus(contractIds: $contractIds, list: $list) {
    code
    message
    validationErrors {
      field
      code
      reason
    }
  }
}
    `;
export type UpdateContractsListStatusMutationFn = Apollo.MutationFunction<UpdateContractsListStatusMutation, UpdateContractsListStatusMutationVariables>;

/**
 * __useUpdateContractsListStatusMutation__
 *
 * To run a mutation, you first call `useUpdateContractsListStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractsListStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractsListStatusMutation, { data, loading, error }] = useUpdateContractsListStatusMutation({
 *   variables: {
 *      contractIds: // value for 'contractIds'
 *      list: // value for 'list'
 *   },
 * });
 */
export function useUpdateContractsListStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractsListStatusMutation, UpdateContractsListStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractsListStatusMutation, UpdateContractsListStatusMutationVariables>(UpdateContractsListStatusDocument, options);
      }
export type UpdateContractsListStatusMutationHookResult = ReturnType<typeof useUpdateContractsListStatusMutation>;
export type UpdateContractsListStatusMutationResult = Apollo.MutationResult<UpdateContractsListStatusMutation>;
export type UpdateContractsListStatusMutationOptions = Apollo.BaseMutationOptions<UpdateContractsListStatusMutation, UpdateContractsListStatusMutationVariables>;
export const GetInitialDataForContractListDocument = gql`
    query getInitialDataForContractList {
  getAllCompanyProductCategories {
    id
    name
  }
}
    `;

/**
 * __useGetInitialDataForContractListQuery__
 *
 * To run a query within a React component, call `useGetInitialDataForContractListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialDataForContractListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialDataForContractListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInitialDataForContractListQuery(baseOptions?: Apollo.QueryHookOptions<GetInitialDataForContractListQuery, GetInitialDataForContractListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialDataForContractListQuery, GetInitialDataForContractListQueryVariables>(GetInitialDataForContractListDocument, options);
      }
export function useGetInitialDataForContractListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialDataForContractListQuery, GetInitialDataForContractListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialDataForContractListQuery, GetInitialDataForContractListQueryVariables>(GetInitialDataForContractListDocument, options);
        }
export type GetInitialDataForContractListQueryHookResult = ReturnType<typeof useGetInitialDataForContractListQuery>;
export type GetInitialDataForContractListLazyQueryHookResult = ReturnType<typeof useGetInitialDataForContractListLazyQuery>;
export type GetInitialDataForContractListQueryResult = Apollo.QueryResult<GetInitialDataForContractListQuery, GetInitialDataForContractListQueryVariables>;
export const GetPaginatedContractsDocument = gql`
    query getPaginatedContracts($page: UnsignedInt, $rowsPerPage: UnsignedInt, $order: String, $orderBy: String, $filters: ContractFilterInput) {
  getPaginatedContracts(
    page: $page
    rowsPerPage: $rowsPerPage
    order: $order
    orderBy: $orderBy
    filters: $filters
  ) {
    pageInfo {
      total
      matches
    }
    contracts {
      id
      writtenDate
      customerName
      customerPhone
      companyProductCategoryId
      itemDescription
      principalAmount
      lastInterestStartingFromDate
      status
      isExpired
      numberOfDaysToLastExpirationDate
      netAmount
      isCompleted
      isListable
      isDeletable
      withinDayId
      isPawnTransaction
      lastPrincipalAmount
    }
    summary {
      totalPrincipalAmount
      totalNetAmount
      expiredCount
    }
  }
}
    `;

/**
 * __useGetPaginatedContractsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedContractsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      rowsPerPage: // value for 'rowsPerPage'
 *      order: // value for 'order'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPaginatedContractsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaginatedContractsQuery, GetPaginatedContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedContractsQuery, GetPaginatedContractsQueryVariables>(GetPaginatedContractsDocument, options);
      }
export function useGetPaginatedContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedContractsQuery, GetPaginatedContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedContractsQuery, GetPaginatedContractsQueryVariables>(GetPaginatedContractsDocument, options);
        }
export type GetPaginatedContractsQueryHookResult = ReturnType<typeof useGetPaginatedContractsQuery>;
export type GetPaginatedContractsLazyQueryHookResult = ReturnType<typeof useGetPaginatedContractsLazyQuery>;
export type GetPaginatedContractsQueryResult = Apollo.QueryResult<GetPaginatedContractsQuery, GetPaginatedContractsQueryVariables>;
export const ExportDailyReportDocument = gql`
    query exportDailyReport($dateKey: PositiveInt!) {
  exportDailyReport(dateKey: $dateKey) {
    code
    downloadableUrl
  }
}
    `;

/**
 * __useExportDailyReportQuery__
 *
 * To run a query within a React component, call `useExportDailyReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportDailyReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportDailyReportQuery({
 *   variables: {
 *      dateKey: // value for 'dateKey'
 *   },
 * });
 */
export function useExportDailyReportQuery(baseOptions: Apollo.QueryHookOptions<ExportDailyReportQuery, ExportDailyReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportDailyReportQuery, ExportDailyReportQueryVariables>(ExportDailyReportDocument, options);
      }
export function useExportDailyReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportDailyReportQuery, ExportDailyReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportDailyReportQuery, ExportDailyReportQueryVariables>(ExportDailyReportDocument, options);
        }
export type ExportDailyReportQueryHookResult = ReturnType<typeof useExportDailyReportQuery>;
export type ExportDailyReportLazyQueryHookResult = ReturnType<typeof useExportDailyReportLazyQuery>;
export type ExportDailyReportQueryResult = Apollo.QueryResult<ExportDailyReportQuery, ExportDailyReportQueryVariables>;
export const GetDailyReportDocument = gql`
    query getDailyReport($dateKey: PositiveInt!) {
  getDailyReport(dateKey: $dateKey) {
    dateKey
    transactions {
      id
      transactionId
      description
      timestamp
      serviceName
      amount
      pawnPrincipalAmount
      pawnInterestAmount
      buySellPrincipalAmount
      buySellInterestAmount
      moneyTransferCashInAmount
      moneyTransferCashOutAmount
      moneyTransferFee
      income
      expense
    }
    summary {
      numberOfTransactions
      principalReceived
      pawnPrincipalAmount
      pawnInterestAmount
      buySellPrincipalAmount
      buySellInterestAmount
      moneyTransferCashInAmount
      moneyTransferCashOutAmount
      moneyTransferFee
      income
      expense
      beginningBalance
      totalAmountInTransactions
      totalInterestAmount
      endingBalance
      overrideEndingBalance
      totalPawnPrincipleAmount
      totalBuySellPrincipleAmount
    }
  }
}
    `;

/**
 * __useGetDailyReportQuery__
 *
 * To run a query within a React component, call `useGetDailyReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyReportQuery({
 *   variables: {
 *      dateKey: // value for 'dateKey'
 *   },
 * });
 */
export function useGetDailyReportQuery(baseOptions: Apollo.QueryHookOptions<GetDailyReportQuery, GetDailyReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyReportQuery, GetDailyReportQueryVariables>(GetDailyReportDocument, options);
      }
export function useGetDailyReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyReportQuery, GetDailyReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyReportQuery, GetDailyReportQueryVariables>(GetDailyReportDocument, options);
        }
export type GetDailyReportQueryHookResult = ReturnType<typeof useGetDailyReportQuery>;
export type GetDailyReportLazyQueryHookResult = ReturnType<typeof useGetDailyReportLazyQuery>;
export type GetDailyReportQueryResult = Apollo.QueryResult<GetDailyReportQuery, GetDailyReportQueryVariables>;
export const UpdateEndingBalanceReportDocument = gql`
    mutation updateEndingBalanceReport($dateKey: PositiveInt!, $endingBalance: Float!) {
  updateEndingBalanceReport(dateKey: $dateKey, endingBalance: $endingBalance) {
    code
  }
}
    `;
export type UpdateEndingBalanceReportMutationFn = Apollo.MutationFunction<UpdateEndingBalanceReportMutation, UpdateEndingBalanceReportMutationVariables>;

/**
 * __useUpdateEndingBalanceReportMutation__
 *
 * To run a mutation, you first call `useUpdateEndingBalanceReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEndingBalanceReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEndingBalanceReportMutation, { data, loading, error }] = useUpdateEndingBalanceReportMutation({
 *   variables: {
 *      dateKey: // value for 'dateKey'
 *      endingBalance: // value for 'endingBalance'
 *   },
 * });
 */
export function useUpdateEndingBalanceReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEndingBalanceReportMutation, UpdateEndingBalanceReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEndingBalanceReportMutation, UpdateEndingBalanceReportMutationVariables>(UpdateEndingBalanceReportDocument, options);
      }
export type UpdateEndingBalanceReportMutationHookResult = ReturnType<typeof useUpdateEndingBalanceReportMutation>;
export type UpdateEndingBalanceReportMutationResult = Apollo.MutationResult<UpdateEndingBalanceReportMutation>;
export type UpdateEndingBalanceReportMutationOptions = Apollo.BaseMutationOptions<UpdateEndingBalanceReportMutation, UpdateEndingBalanceReportMutationVariables>;
export const GetInvestedPrincipalReportDocument = gql`
    query getInvestedPrincipalReport {
  getInvestedPrincipalReport {
    amount
    investor {
      name
    }
  }
}
    `;

/**
 * __useGetInvestedPrincipalReportQuery__
 *
 * To run a query within a React component, call `useGetInvestedPrincipalReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestedPrincipalReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestedPrincipalReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInvestedPrincipalReportQuery(baseOptions?: Apollo.QueryHookOptions<GetInvestedPrincipalReportQuery, GetInvestedPrincipalReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvestedPrincipalReportQuery, GetInvestedPrincipalReportQueryVariables>(GetInvestedPrincipalReportDocument, options);
      }
export function useGetInvestedPrincipalReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvestedPrincipalReportQuery, GetInvestedPrincipalReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvestedPrincipalReportQuery, GetInvestedPrincipalReportQueryVariables>(GetInvestedPrincipalReportDocument, options);
        }
export type GetInvestedPrincipalReportQueryHookResult = ReturnType<typeof useGetInvestedPrincipalReportQuery>;
export type GetInvestedPrincipalReportLazyQueryHookResult = ReturnType<typeof useGetInvestedPrincipalReportLazyQuery>;
export type GetInvestedPrincipalReportQueryResult = Apollo.QueryResult<GetInvestedPrincipalReportQuery, GetInvestedPrincipalReportQueryVariables>;
export const ExportMonthlyReportDocument = gql`
    query exportMonthlyReport($monthKey: PositiveInt!) {
  exportMonthlyReport(monthKey: $monthKey) {
    code
    downloadableUrl
  }
}
    `;

/**
 * __useExportMonthlyReportQuery__
 *
 * To run a query within a React component, call `useExportMonthlyReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportMonthlyReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportMonthlyReportQuery({
 *   variables: {
 *      monthKey: // value for 'monthKey'
 *   },
 * });
 */
export function useExportMonthlyReportQuery(baseOptions: Apollo.QueryHookOptions<ExportMonthlyReportQuery, ExportMonthlyReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportMonthlyReportQuery, ExportMonthlyReportQueryVariables>(ExportMonthlyReportDocument, options);
      }
export function useExportMonthlyReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportMonthlyReportQuery, ExportMonthlyReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportMonthlyReportQuery, ExportMonthlyReportQueryVariables>(ExportMonthlyReportDocument, options);
        }
export type ExportMonthlyReportQueryHookResult = ReturnType<typeof useExportMonthlyReportQuery>;
export type ExportMonthlyReportLazyQueryHookResult = ReturnType<typeof useExportMonthlyReportLazyQuery>;
export type ExportMonthlyReportQueryResult = Apollo.QueryResult<ExportMonthlyReportQuery, ExportMonthlyReportQueryVariables>;
export const GetMonthlyReportDocument = gql`
    query getMonthlyReport($monthKey: PositiveInt!) {
  getMonthlyReport(monthKey: $monthKey) {
    days {
      dateKey
      principalReceived
      pawnPrincipalAdvanceAmount
      pawnPrincipalRecoupeAmount
      pawnInterestAmount
      buySellPrincipalAdvanceAmount
      buySellPrincipalRecoupeAmount
      buySellInterestAmount
      moneyTransferAmount
      moneyTransferFee
      totalIncome
      totalExpense
      numberOfDaysToCalculatePrincipalInterest
      endingBalance
      overrideEndingBalance
      endingBalanceDifference
      totalBuySellPrincipleAmount
      totalPawnPrincipleAmount
    }
    summary {
      numberOfDays
      principalReceived
      pawnPrincipalAdvanceAmount
      pawnPrincipalRecoupeAmount
      pawnInterestAmount
      buySellPrincipalAdvanceAmount
      buySellPrincipalRecoupeAmount
      buySellInterestAmount
      moneyTransferAmount
      moneyTransferFee
      totalIncome
      totalExpense
      totalInterestAmount
    }
  }
}
    `;

/**
 * __useGetMonthlyReportQuery__
 *
 * To run a query within a React component, call `useGetMonthlyReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonthlyReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonthlyReportQuery({
 *   variables: {
 *      monthKey: // value for 'monthKey'
 *   },
 * });
 */
export function useGetMonthlyReportQuery(baseOptions: Apollo.QueryHookOptions<GetMonthlyReportQuery, GetMonthlyReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMonthlyReportQuery, GetMonthlyReportQueryVariables>(GetMonthlyReportDocument, options);
      }
export function useGetMonthlyReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMonthlyReportQuery, GetMonthlyReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMonthlyReportQuery, GetMonthlyReportQueryVariables>(GetMonthlyReportDocument, options);
        }
export type GetMonthlyReportQueryHookResult = ReturnType<typeof useGetMonthlyReportQuery>;
export type GetMonthlyReportLazyQueryHookResult = ReturnType<typeof useGetMonthlyReportLazyQuery>;
export type GetMonthlyReportQueryResult = Apollo.QueryResult<GetMonthlyReportQuery, GetMonthlyReportQueryVariables>;